import {
  linkTypeMap,
  createClient as createClientOriginal,
  generateGraphqlOperation,
  assertSameVersion,
} from '@genql/runtime'
import types from './types.esm'
var typeMap = linkTypeMap(types)
export * from './guards.esm'

export var version = '2.10.0'
assertSameVersion(version)

export var createClient = function(options) {
  options = options || {}
  var optionsCopy = {
    url: 'https://gql-internal.myfinaloop.com',
    queryRoot: typeMap.Query,
    mutationRoot: typeMap.Mutation,
    subscriptionRoot: typeMap.Subscription,
  }
  for (var name in options) {
    optionsCopy[name] = options[name]
  }
  return createClientOriginal(optionsCopy)
}

export const enumAccountingMethod = {
  accrual: 'accrual',
  cash: 'cash',
}

export const enumAccountingServicesTypes = {
  NOT_INTERESTED: 'NOT_INTERESTED',
  INTERESTED: 'INTERESTED',
  NO_STORE: 'NO_STORE',
  AUTOMATED: 'AUTOMATED',
  FULLY_MANAGED: 'FULLY_MANAGED',
}

export const enumAccountState = {
  ACTIVE: 'ACTIVE',
  MADE_PRIVATE: 'MADE_PRIVATE',
  CLOSED: 'CLOSED',
  ASSUMED_MADE_PRIVATE: 'ASSUMED_MADE_PRIVATE',
  ASSUMED_CLOSED: 'ASSUMED_CLOSED',
}

export const enumAccountStatus = {
  VALID: 'VALID',
  ISSUE: 'ISSUE',
}

export const enumAccrualEntityType = {
  BANK_TRANSACTION: 'BANK_TRANSACTION',
  BILL: 'BILL',
}

export const enumAccrualRecordSource = {
  Transactions: 'Transactions',
  Bills: 'Bills',
  Historical: 'Historical',
}

export const enumAccrualsStatus = {
  FAILURE: 'FAILURE',
  SUCCESS: 'SUCCESS',
}

export const enumAccrualType = {
  ALL: 'ALL',
  FIXED_ASSETS: 'FIXED_ASSETS',
  PREPAID_EXPENSES: 'PREPAID_EXPENSES',
  ACCRUED_EXPENSES: 'ACCRUED_EXPENSES',
}

export const enumActionChangeMoneyDirection = {
  INCREASE: 'INCREASE',
  DECREASE: 'DECREASE',
}

export const enumActorType = {
  INTEGRATION: 'INTEGRATION',
  FINALOOP_TEAM: 'FINALOOP_TEAM',
  FINALOOP_CUSTOMER: 'FINALOOP_CUSTOMER',
  LOCAL_RULE: 'LOCAL_RULE',
  MACHINE: 'MACHINE',
  MACHINE_FORCE: 'MACHINE_FORCE',
  NTROPY: 'NTROPY',
  DATA_DELETER: 'DATA_DELETER',
  DATA_SCIENCE_CLEAR: 'DATA_SCIENCE_CLEAR',
  SYSTEM: 'SYSTEM',
  REALTIME_RULE_APPLIER: 'REALTIME_RULE_APPLIER',
  MISSION: 'MISSION',
  INITIAL_MIGRATION: 'INITIAL_MIGRATION',
  DUPLICATE_DETECTOR: 'DUPLICATE_DETECTOR',
  DUPLICATE_MERGER: 'DUPLICATE_MERGER',
  ZERO_AMOUNT_DELETER: 'ZERO_AMOUNT_DELETER',
}

export const enumAdjustmentType = {
  PAID_HISTORICALLY: 'PAID_HISTORICALLY',
  UNCOLLECTIBLE: 'UNCOLLECTIBLE',
  COLLECTIBLE: 'COLLECTIBLE',
}

export const enumAllSkusSortField = {
  SALES: 'SALES',
  SALES_TREND: 'SALES_TREND',
  DISCOUNTS: 'DISCOUNTS',
  COGS: 'COGS',
  PROFIT: 'PROFIT',
  MARGIN: 'MARGIN',
  REFUNDS: 'REFUNDS',
  RESTOCKS: 'RESTOCKS',
  EFFECTIVE_PROFIT: 'EFFECTIVE_PROFIT',
  EFFECTIVE_PROFIT_MARGIN: 'EFFECTIVE_PROFIT_MARGIN',
  UNITS_SOLD: 'UNITS_SOLD',
  UNITS_REFUNDED: 'UNITS_REFUNDED',
  AVERAGE_UNITS_SOLD: 'AVERAGE_UNITS_SOLD',
  AVERAGE_SALE_PRICE: 'AVERAGE_SALE_PRICE',
  AVERAGE_NET_SALES: 'AVERAGE_NET_SALES',
  AVERAGE_COST_PER_UNIT: 'AVERAGE_COST_PER_UNIT',
  AVERAGE_PROFIT_PER_UNIT: 'AVERAGE_PROFIT_PER_UNIT',
}

export const enumApplyPendingSalesDataAdjustmentsMode = {
  ADD_ON_TOP: 'ADD_ON_TOP',
  REPLACE: 'REPLACE',
}

export const enumArtificialTransactionsType = {
  PAYMENT: 'PAYMENT',
  REFUND: 'REFUND',
}

export const enumAskTheUserFlowType = {
  FEDERAL_TAX_PAID_FLOW_TYPE: 'FEDERAL_TAX_PAID_FLOW_TYPE',
  STATE_AND_SALES_TAXES_PAID_FLOW_TYPE: 'STATE_AND_SALES_TAXES_PAID_FLOW_TYPE',
  PAYROLL_FLOW_TYPE: 'PAYROLL_FLOW_TYPE',
  PENSION_FLOW_TYPE: 'PENSION_FLOW_TYPE',
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
  REFUND: 'REFUND',
  DISTRIBUTION: 'DISTRIBUTION',
  PAYOUTS_TOP_UPS: 'PAYOUTS_TOP_UPS',
}

export const enumAskTheUserNotificationType = {
  PAYROLL_PROVIDER_IDENTIFIED_BY_USER: 'PAYROLL_PROVIDER_IDENTIFIED_BY_USER',
  PAYOUTS_TOPUPS_SHOPIFY_PAYMENT_GATEWAY_NO_CONFIG:
    'PAYOUTS_TOPUPS_SHOPIFY_PAYMENT_GATEWAY_NO_CONFIG',
  PAYOUTS_TOPUPS_CONNECTION_FAILURE: 'PAYOUTS_TOPUPS_CONNECTION_FAILURE',
  PAYOUTS_TOPUPS_USER_SELECTED_INTEGRATION:
    'PAYOUTS_TOPUPS_USER_SELECTED_INTEGRATION',
  PAYOUTS_TOPUPS_USER_SELECTED_WALMART_CONNECTED_INTEGRATION:
    'PAYOUTS_TOPUPS_USER_SELECTED_WALMART_CONNECTED_INTEGRATION',
  INTERNAL_TRANSFER_PAYPAL_RECLASSIFICATION:
    'INTERNAL_TRANSFER_PAYPAL_RECLASSIFICATION',
  PAYOUTS_TOP_UPS_FROM_MISSION_LENDER_SELECTED:
    'PAYOUTS_TOP_UPS_FROM_MISSION_LENDER_SELECTED',
  PAYOUTS_TOP_UPS_FROM_MISSION_RELATED_PARTY_SELECTED:
    'PAYOUTS_TOP_UPS_FROM_MISSION_RELATED_PARTY_SELECTED',
  PAYOUTS_TOP_UPS_FROM_MISSION_OTHER_THIRDPARTY_SELECTED:
    'PAYOUTS_TOP_UPS_FROM_MISSION_OTHER_THIRDPARTY_SELECTED',
  PAYOUTS_TOP_UPS_FROM_MISSION_PAYPAL_SELECTED:
    'PAYOUTS_TOP_UPS_FROM_MISSION_PAYPAL_SELECTED',
  PAYOUTS_TOP_UPS_FROM_MISSION_TRANSACTION_MATCHED:
    'PAYOUTS_TOP_UPS_FROM_MISSION_TRANSACTION_MATCHED',
  PAYOUTS_TOP_UPS_FROM_MISSION_CUSTOM_CLASSIFICATION:
    'PAYOUTS_TOP_UPS_FROM_MISSION_CUSTOM_CLASSIFICATION',
  PAYOUTS_TOP_UPS_USER_UPLOADED_INTEGRATION_FILE:
    'PAYOUTS_TOP_UPS_USER_UPLOADED_INTEGRATION_FILE',
}

export const enumAssemblyDeletedReason = {
  MERGE: 'MERGE',
  USER_MANUAL: 'USER_MANUAL',
}

export const enumAssemblyType = {
  ON_DEMAND: 'ON_DEMAND',
  MANUAL: 'MANUAL',
}

export const enumBackOfficeCreateBankReconciliationRequestType = {
  BULK_PDF: 'BULK_PDF',
  MISSING_TXNS: 'MISSING_TXNS',
  ONE_TIME_RECONCILIATION: 'ONE_TIME_RECONCILIATION',
  RECURRING_CSV: 'RECURRING_CSV',
}

export const enumBalanceSheetItemType = {
  BUSINESS_AND_TAX_INFORMATION: 'BUSINESS_AND_TAX_INFORMATION',
  BANKS: 'BANKS',
  LOANS: 'LOANS',
  TAX_RETURN_DOCUMENT: 'TAX_RETURN_DOCUMENT',
  BALANCE_SHEET_DOCUMENT: 'BALANCE_SHEET_DOCUMENT',
  ACQUISITION_AGREEMENT_DOCUMENT: 'ACQUISITION_AGREEMENT_DOCUMENT',
}

export const enumBalanceSheetSetupItemErrorMessage = {
  BALANCE_SHEET_IS_NOT_EDITABLE: 'BALANCE_SHEET_IS_NOT_EDITABLE',
}

export const enumBankAccountBalanceAdjustmentActorType = {
  MANUAL_STREAMLIT: 'MANUAL_STREAMLIT',
  AUTOMATIC_DATA_JOBS: 'AUTOMATIC_DATA_JOBS',
  AUTOMATIC_DATA_JOBS_OPENING_BALANCE_STATEMENT:
    'AUTOMATIC_DATA_JOBS_OPENING_BALANCE_STATEMENT',
}

export const enumBankAccountClosingBalanceActorType = {
  MANUAL_STREAMLIT: 'MANUAL_STREAMLIT',
  AUTOMATIC_DATA_JOBS: 'AUTOMATIC_DATA_JOBS',
  AUTOMATIC_DATA_JOBS_OPENING_BALANCE_STATEMENT:
    'AUTOMATIC_DATA_JOBS_OPENING_BALANCE_STATEMENT',
}

export const enumBankAccountConnectionStatus = {
  Connected: 'Connected',
  Disconnected: 'Disconnected',
}

export const enumBankAccountNewOwnerType = {
  THIRD_PARTY: 'THIRD_PARTY',
  RELATED_PARTY: 'RELATED_PARTY',
  OWNER: 'OWNER',
}

export const enumBankAccountReconciliationStatus = {
  PENDING_USER_ACTION: 'PENDING_USER_ACTION',
  COMPLETED: 'COMPLETED',
}

export const enumBankAccountStatementFileType = {
  CSV: 'CSV',
  PDF: 'PDF',
  XLSX: 'XLSX',
  XLS: 'XLS',
  UNSUPPORTED: 'UNSUPPORTED',
}

export const enumBankAccountStatementRequestStatus = {
  NOT_REQUIRED: 'NOT_REQUIRED',
  IRRELEVANT: 'IRRELEVANT',
  PENDING_USER_INPUT: 'PENDING_USER_INPUT',
  USER_COMPLETED: 'USER_COMPLETED',
  FINALOOP_APPROVED: 'FINALOOP_APPROVED',
  IRRELEVANT_APPROVED: 'IRRELEVANT_APPROVED',
}

export const enumBankAccountStatementRequestSubType = {
  MADE_PRIVATE_WHILE_INVALID: 'MADE_PRIVATE_WHILE_INVALID',
  ASSUMED_CLOSED: 'ASSUMED_CLOSED',
  STOP_IMPORT: 'STOP_IMPORT',
}

export const enumBankAccountStatementRequestType = {
  END_OF_YEAR_BALANCE: 'END_OF_YEAR_BALANCE',
  START_OF_YEAR_BALANCE: 'START_OF_YEAR_BALANCE',
  TRANSACTIONS_BACKFILL: 'TRANSACTIONS_BACKFILL',
  INTERNAL_TRANSFER_TRANSACTION_MATCH: 'INTERNAL_TRANSFER_TRANSACTION_MATCH',
}

export const enumBankAccountStatus = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  DUPLICATE: 'DUPLICATE',
  SUSPECTED_AS_DUPLICATE: 'SUSPECTED_AS_DUPLICATE',
  DELETED: 'DELETED',
  MERGING: 'MERGING',
  MERGED: 'MERGED',
  MERGE_DESTINATION: 'MERGE_DESTINATION',
}

export const enumBankAccountSubtype = {
  Checking: 'Checking',
  Savings: 'Savings',
  CreditCard: 'CreditCard',
  Loan: 'Loan',
  CompanyAffiliateBalance: 'CompanyAffiliateBalance',
  DueToFromOwner: 'DueToFromOwner',
  ShortTermLoanTaken: 'ShortTermLoanTaken',
  Unknown: 'Unknown',
  LineOfCredit: 'LineOfCredit',
}

export const enumBankAccountType = {
  Depository: 'Depository',
  CreditCard: 'CreditCard',
  Loan: 'Loan',
  Investment: 'Investment',
  Other: 'Other',
}

export const enumBankConnectionAccountStatus = {
  HEALTHY: 'HEALTHY',
  IMPORT_STOPPED: 'IMPORT_STOPPED',
  ACCESS_REMOVED: 'ACCESS_REMOVED',
  DISCONNECTED: 'DISCONNECTED',
}

export const enumBankConnectionMetricsEventType = {
  INTEGRATION_DISCONNECTED: 'INTEGRATION_DISCONNECTED',
  INTEGRATION_RECONNECTED: 'INTEGRATION_RECONNECTED',
  INTEGRATION_REFRESH_REQUIRED: 'INTEGRATION_REFRESH_REQUIRED',
}

export const enumBankConnectionSortType = {
  DEFAULT: 'DEFAULT',
  BANKS_OVERVIEW_PAGE: 'BANKS_OVERVIEW_PAGE',
}

export const enumBankConnectionStatus = {
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',
  PENDING_REFRESH: 'PENDING_REFRESH',
  NO_ACTIVE_CONNECTION: 'NO_ACTIVE_CONNECTION',
}

export const enumBankingAuditAction = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
}

export const enumBankingMetricEventType = {
  INTEGRATION_DISCONNECTED: 'INTEGRATION_DISCONNECTED',
  INTEGRATION_RECONNECTED: 'INTEGRATION_RECONNECTED',
  INTEGRATION_REFRESH_REQUIRED: 'INTEGRATION_REFRESH_REQUIRED',
}

export const enumBankReconciliationConfigurableRequestType = {
  RECURRING_CSV: 'RECURRING_CSV',
}

export const enumBankReconciliationRequestCategory = {
  UPLOAD_FILES: 'UPLOAD_FILES',
  RECONCILIATION: 'RECONCILIATION',
  CONNECTION: 'CONNECTION',
}

export const enumBankReconciliationRequestFilesStatus = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  NOT_RELEVANT: 'NOT_RELEVANT',
}

export const enumBankReconciliationRequestMachineStatus = {
  WAITING_FOR_AUTOMATIC_PROCESSING: 'WAITING_FOR_AUTOMATIC_PROCESSING',
  WAITING_FOR_MANUAL_PROCESSING: 'WAITING_FOR_MANUAL_PROCESSING',
  DONE: 'DONE',
  FAILURE: 'FAILURE',
  NOT_RELEVANT: 'NOT_RELEVANT',
}

export const enumBankReconciliationRequestRecurrence = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
}

export const enumBankReconciliationRequestStatusCategories = {
  OPEN: 'OPEN',
  PROCESSING: 'PROCESSING',
  CLOSED: 'CLOSED',
}

export const enumBankReconciliationSettingsRequestTypes = {
  BULK_PDF: 'BULK_PDF',
  HISTORICAL_GAP: 'HISTORICAL_GAP',
  MISSING_TXNS: 'MISSING_TXNS',
  ONE_TIME_RECONCILIATION: 'ONE_TIME_RECONCILIATION',
  RECURRING_CSV: 'RECURRING_CSV',
}

export const enumBankStatementAutoProcessingStatus = {
  SUCCESS: 'SUCCESS',
  PENDING: 'PENDING',
  FAILED: 'FAILED',
}

export const enumBankStatementFileProcessingLogState = {
  IN_PROGRESS: 'IN_PROGRESS',
  FINISHED: 'FINISHED',
  ERROR: 'ERROR',
  MARKED_AS_DONE: 'MARKED_AS_DONE',
  MARKED_AS_NOT_RELEVANT: 'MARKED_AS_NOT_RELEVANT',
}

export const enumBankStatementFileProcessorType = {
  MANUAL: 'MANUAL',
  AUTOMATIC: 'AUTOMATIC',
  VIRTUAL_ASSISTANT: 'VIRTUAL_ASSISTANT',
  TRANSACTIONS_UPLOADER: 'TRANSACTIONS_UPLOADER',
}

export const enumBankStatementFileStatus = {
  WAITING_FOR_AUTOMATIC_PROCESSING: 'WAITING_FOR_AUTOMATIC_PROCESSING',
  AUTOMATIC_PROCESS_RUNNING: 'AUTOMATIC_PROCESS_RUNNING',
  AUTOMATIC_PROCESS_FINISHED: 'AUTOMATIC_PROCESS_FINISHED',
  AUTOMATIC_PROCESS_FAILURE: 'AUTOMATIC_PROCESS_FAILURE',
  WAITING_FOR_MANUAL_PROCESSING: 'WAITING_FOR_MANUAL_PROCESSING',
  MANUAL_PROCESS_RUNNING: 'MANUAL_PROCESS_RUNNING',
  MANUAL_PROCESS_FINISHED: 'MANUAL_PROCESS_FINISHED',
  MANUAL_PROCESS_FAILURE: 'MANUAL_PROCESS_FAILURE',
  WAITING_FOR_TRANSACTIONS_UPLOADER: 'WAITING_FOR_TRANSACTIONS_UPLOADER',
  TRANSACTIONS_UPLOADER_RUNNING: 'TRANSACTIONS_UPLOADER_RUNNING',
  TRANSACTIONS_UPLOADER_FINISHED: 'TRANSACTIONS_UPLOADER_FINISHED',
  DONE: 'DONE',
  FAILURE: 'FAILURE',
  NOT_RELEVANT: 'NOT_RELEVANT',
}

export const enumBankStatementFileSubSystem = {
  BULK_PDF: 'BULK_PDF',
  CLOSING_BALANCE: 'CLOSING_BALANCE',
  CUSTOMER_MANUAL_TRANSACTIONS_UPLOAD: 'CUSTOMER_MANUAL_TRANSACTIONS_UPLOAD',
  FILES_MANAGEMENT_BACKOFFICE: 'FILES_MANAGEMENT_BACKOFFICE',
  HISTORICAL_GAP: 'HISTORICAL_GAP',
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
  MISSING_TXNS: 'MISSING_TXNS',
  ONGOING_RECONCILIATION: 'ONGOING_RECONCILIATION',
  OPENING_BALANCE: 'OPENING_BALANCE',
  PAYOUTS_AND_TOPUPS: 'PAYOUTS_AND_TOPUPS',
  RECURRING_CSV: 'RECURRING_CSV',
  REPORTED_TRANSACTIONS: 'REPORTED_TRANSACTIONS',
  STREAMLIT: 'STREAMLIT',
  TRANSACTIONS_BACKFILL: 'TRANSACTIONS_BACKFILL',
  TRANSACTIONS_CSV_UPLOAD: 'TRANSACTIONS_CSV_UPLOAD',
}

export const enumBankStatementFilesValidationProvider = {
  OPEN_AI: 'OPEN_AI',
  HERON: 'HERON',
  NTROPY: 'NTROPY',
}

export const enumBankStatementFileSystem = {
  ATU: 'ATU',
  ATU_INTEGRATIONS: 'ATU_INTEGRATIONS',
  BACKOFFICE: 'BACKOFFICE',
  STATEMENT_REQUESTS: 'STATEMENT_REQUESTS',
}

export const enumBankStatementParsingRequestsProvider = {
  OPEN_AI: 'OPEN_AI',
  HERON: 'HERON',
  NTROPY: 'NTROPY',
}

export const enumBankStatementParsingRequestsRunStatus = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  TIMEOUT: 'TIMEOUT',
}

export const enumBankStatementParsingResultStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
}

export const enumBankStatementReconciliationIrrelevantReason = {
  ACCOUNT_CLOSED: 'ACCOUNT_CLOSED',
  OWNERS_PERSONAL_ACCOUNT: 'OWNERS_PERSONAL_ACCOUNT',
  OWNED_BY_RELATED_BUSINESS: 'OWNED_BY_RELATED_BUSINESS',
  TRANSFERRED_FROM_BUSINESS: 'TRANSFERRED_FROM_BUSINESS',
  TRANSFERRED_TO_BUSINESS: 'TRANSFERRED_TO_BUSINESS',
  ACCOUNT_OPENED_AFTER_REQUESTED_DATE: 'ACCOUNT_OPENED_AFTER_REQUESTED_DATE',
  USER_SAID_NO_MISSING_TXNS: 'USER_SAID_NO_MISSING_TXNS',
  USER_SAID_NO_RELEVANT_BANK_STATEMENTS:
    'USER_SAID_NO_RELEVANT_BANK_STATEMENTS',
}

export const enumBankStatementReconciliationResolutionType = {
  IRRELEVANT: 'IRRELEVANT',
  STANDARD: 'STANDARD',
  MADE_PRIVATE: 'MADE_PRIVATE',
  ASSUMED_CLOSED: 'ASSUMED_CLOSED',
  CONVERT_TO_MANUAL: 'CONVERT_TO_MANUAL',
  SEND_TO_OPS: 'SEND_TO_OPS',
}

export const enumBankStatementReconciliationTransferredEntity = {
  BUSINESS_OWNER: 'BUSINESS_OWNER',
  RELATED_PARTY: 'RELATED_PARTY',
  THIRD_PARTY: 'THIRD_PARTY',
}

export const enumBankStatementRequestCategory = {
  UPLOAD_FILES: 'UPLOAD_FILES',
  RECONCILIATION: 'RECONCILIATION',
  CONNECTION: 'CONNECTION',
  UPLOAD_PDF: 'UPLOAD_PDF',
}

export const enumBankStatementRequestStatus = {
  CUSTOMER_ACTION_REQUIRED: 'CUSTOMER_ACTION_REQUIRED',
  PENDING_FINALOOP_REVIEW: 'PENDING_FINALOOP_REVIEW',
  FINALOOP_APPROVED: 'FINALOOP_APPROVED',
  CUSTOMER_CLOSED: 'CUSTOMER_CLOSED',
  IRRELEVANT_ASSUMED_FINALOOP: 'IRRELEVANT_ASSUMED_FINALOOP',
  PENDING_AUTOMATIC_PROCESSING: 'PENDING_AUTOMATIC_PROCESSING',
}

export const enumBankStatementRequestSubmissionStatus = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  FAILED: 'FAILED',
}

export const enumBankStatementRequestType = {
  OPENING: 'OPENING',
  CLOSING: 'CLOSING',
  ONGOING: 'ONGOING',
  RECURRING_CSV: 'RECURRING_CSV',
  BULK_PDF: 'BULK_PDF',
  MISSING_TXNS: 'MISSING_TXNS',
  ONE_TIME_RECONCILIATION: 'ONE_TIME_RECONCILIATION',
  HISTORICAL_GAP: 'HISTORICAL_GAP',
  ACCESS_REMOVED: 'ACCESS_REMOVED',
  REPORT_TRANSACTIONS: 'REPORT_TRANSACTIONS',
}

export const enumBankStatementResolutionOriginator = {
  ATUBanking: 'ATUBanking',
  ATUIntegrations: 'ATUIntegrations',
  ATUWalmartHyperwallet: 'ATUWalmartHyperwallet',
  BackOffice: 'BackOffice',
  BankAccountReconciliation: 'BankAccountReconciliation',
  BankAccountStatementsReconciliation: 'BankAccountStatementsReconciliation',
  BankingPage: 'BankingPage',
  ClosingBalanceRequest: 'ClosingBalanceRequest',
  CustomerManualTransactionsUpload: 'CustomerManualTransactionsUpload',
  InternalTransferTransactionMatch: 'InternalTransferTransactionMatch',
  OngoingReconciliationRequest: 'OngoingReconciliationRequest',
  OpeningBalanceRequest: 'OpeningBalanceRequest',
  PayoutsAndTopUps: 'PayoutsAndTopUps',
  ReportedTransactions: 'ReportedTransactions',
  TransactionsBackfill: 'TransactionsBackfill',
  TransactionsBackOfficeStreamlit: 'TransactionsBackOfficeStreamlit',
  TransactionsCSVUpload: 'TransactionsCSVUpload',
}

export const enumBankStatementValidationRunStatus = {
  PENDING: 'PENDING',
  VALID: 'VALID',
  INVALID: 'INVALID',
  API_FAILED: 'API_FAILED',
  TIMEOUT: 'TIMEOUT',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
}

export const enumBankStatementVerificationComponents = {
  MASK: 'MASK',
  INSTITUTION: 'INSTITUTION',
}

export const enumBankTransactionCategorizationResultStatus = {
  FAILURE: 'FAILURE',
  SUCCESS: 'SUCCESS',
}

export const enumBankTransactionClassifierType = {
  LOCAL_RULE: 'LOCAL_RULE',
  RULE: 'RULE',
  USER: 'USER',
  INTEGRATION: 'INTEGRATION',
  DATA_DELETER: 'DATA_DELETER',
  FINALOOP_TEAM: 'FINALOOP_TEAM',
  FINALOOP_CUSTOMER: 'FINALOOP_CUSTOMER',
  NTROPY: 'NTROPY',
}

export const enumBankTransactionsUploadProcessingLogState = {
  IN_PROGRESS: 'IN_PROGRESS',
  FINISHED: 'FINISHED',
  ERROR: 'ERROR',
  MARKED_AS_DONE: 'MARKED_AS_DONE',
}

export const enumBankTransactionsUploadProcessorType = {
  MANUAL: 'MANUAL',
  AUTOMATIC: 'AUTOMATIC',
  VIRTUAL_ASSISTANT: 'VIRTUAL_ASSISTANT',
  TRANSACTIONS_UPLOADER: 'TRANSACTIONS_UPLOADER',
}

export const enumBankTransactionsUploadStatus = {
  WAITING_FOR_AUTOMATIC_PROCESSING: 'WAITING_FOR_AUTOMATIC_PROCESSING',
  AUTOMATIC_PROCESS_RUNNING: 'AUTOMATIC_PROCESS_RUNNING',
  AUTOMATIC_PROCESS_FINISHED: 'AUTOMATIC_PROCESS_FINISHED',
  AUTOMATIC_PROCESS_FAILURE: 'AUTOMATIC_PROCESS_FAILURE',
  WAITING_FOR_MANUAL_PROCESSING: 'WAITING_FOR_MANUAL_PROCESSING',
  MANUAL_PROCESS_RUNNING: 'MANUAL_PROCESS_RUNNING',
  MANUAL_PROCESS_FINISHED: 'MANUAL_PROCESS_FINISHED',
  MANUAL_PROCESS_FAILURE: 'MANUAL_PROCESS_FAILURE',
  WAITING_FOR_TRANSACTIONS_UPLOADER: 'WAITING_FOR_TRANSACTIONS_UPLOADER',
  TRANSACTIONS_UPLOADER_RUNNING: 'TRANSACTIONS_UPLOADER_RUNNING',
  TRANSACTIONS_UPLOADER_FINISHED: 'TRANSACTIONS_UPLOADER_FINISHED',
  DONE: 'DONE',
  FAILURE: 'FAILURE',
}

export const enumBillAdjustmentType = {
  PRIOR_YEAR_ADJUSTMENT: 'PRIOR_YEAR_ADJUSTMENT',
  FULLY_REFUNDED: 'FULLY_REFUNDED',
}

export const enumBillPaymentFinancingType = {
  EPT: 'EPT',
  BEPT: 'BEPT',
  AMORTIZED: 'AMORTIZED',
}

export const enumBillPaymentSettlementType = {
  PAID_EXTERNALLY: 'PAID_EXTERNALLY',
  PAID_VIA_INTEGRATION: 'PAID_VIA_INTEGRATION',
  FINANCED_BY_INTEGRATION: 'FINANCED_BY_INTEGRATION',
  FINANCED_EXTERNALLY: 'FINANCED_EXTERNALLY',
  SCHEDULED: 'SCHEDULED',
  INDICATIVE: 'INDICATIVE',
  MANUAL_BY_FINALOOP_TEAM: 'MANUAL_BY_FINALOOP_TEAM',
}

export const enumBillRefundSettlementType = {
  REFUNDED_VIA_INTEGRATION: 'REFUNDED_VIA_INTEGRATION',
  SCHEDULED: 'SCHEDULED',
  INDICATIVE: 'INDICATIVE',
  MANUAL_BY_FINALOOP_TEAM: 'MANUAL_BY_FINALOOP_TEAM',
}

export const enumBillsYearEndTaskId = {
  CATEGORIZE_UNCATEGORIZED_BILLS: 'CATEGORIZE_UNCATEGORIZED_BILLS',
  CLOSE_OPEN_BILLS: 'CLOSE_OPEN_BILLS',
  ADD_MISSING_BILLS: 'ADD_MISSING_BILLS',
  CONFIRM_AP_BALANCE: 'CONFIRM_AP_BALANCE',
}

export const enumBillsYearEndTaskStatus = {
  INACTIVE: 'INACTIVE',
  OPEN: 'OPEN',
  REOPENED: 'REOPENED',
  PROCESSING: 'PROCESSING',
  CLOSED: 'CLOSED',
}

export const enumBreakdownType = {
  CATEGORY: 'CATEGORY',
  MERCHANT: 'MERCHANT',
}

export const enumBusinessCreationType = {
  CREATED: 'CREATED',
  PURCHASED: 'PURCHASED',
}

export const enumClosingBalanceType = {
  INTEGRATION_UDF: 'INTEGRATION_UDF',
}

export const enumCogsCategory = {
  ProductDirectCost: 'ProductDirectCost',
  ShippingAndFreightIn: 'ShippingAndFreightIn',
  CustomFeesAndServices: 'CustomFeesAndServices',
  DutiesAndTax: 'DutiesAndTax',
  Insurance: 'Insurance',
  PalletCosts: 'PalletCosts',
  ShippingSurcharge: 'ShippingSurcharge',
  VendorFees: 'VendorFees',
  ProductionCosts: 'ProductionCosts',
  Discount: 'Discount',
  PackagingMaterials: 'PackagingMaterials',
  Dropshipping: 'Dropshipping',
  ProductionLaborCosts: 'ProductionLaborCosts',
  ManufacturingCosts: 'ManufacturingCosts',
  ManufacturingLabor: 'ManufacturingLabor',
  Printing: 'Printing',
  InventoryMaintenance: 'InventoryMaintenance',
  General: 'General',
  OtherInventoryAdjustments: 'OtherInventoryAdjustments',
  WarrantyReimbursement: 'WarrantyReimbursement',
}

export const enumCogsEventSource = {
  system: 'system',
  user: 'user',
  incidentals: 'incidentals',
}

export const enumCogsSource = {
  Products: 'Products',
  Incidentals: 'Incidentals',
  Manual: 'Manual',
}

export const enumCogsType = {
  COGS: 'COGS',
  DeadInventory: 'DeadInventory',
  ProductGiveaways: 'ProductGiveaways',
  Waste: 'Waste',
  PhysicalAdjustments: 'PhysicalAdjustments',
  ProductDonations: 'ProductDonations',
  UnitLost: 'UnitLost',
  UnitFound: 'UnitFound',
  OtherFba: 'OtherFba',
  SupplierReturn: 'SupplierReturn',
}

export const enumCompanyAffiliateType = {
  holder: 'holder',
  safeHolder: 'safeHolder',
  relatedParty: 'relatedParty',
  employee: 'employee',
  contractor: 'contractor',
  lender: 'lender',
}

export const enumCompanyHealthStatusSortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
}

export const enumCompanyLoanDeleteOptionMode = {
  NOT_IN_BOOKS: 'NOT_IN_BOOKS',
  MANUAL_EVENTS_ONLY: 'MANUAL_EVENTS_ONLY',
  ONLY_TRANSACTIONS_EVENTS: 'ONLY_TRANSACTIONS_EVENTS',
  HAS_INTEGRATION_EVENTS: 'HAS_INTEGRATION_EVENTS',
}

export const enumCompanyTier = {
  TIER_1_V3: 'TIER_1_V3',
  TIER_2_V3: 'TIER_2_V3',
  TIER_3_V3: 'TIER_3_V3',
  TIER_4_V3: 'TIER_4_V3',
  TIER_5_V3: 'TIER_5_V3',
  TIER_6_V3: 'TIER_6_V3',
  TIER_7_V3: 'TIER_7_V3',
}

export const enumCompanyTierType = {
  TIER_1: 'TIER_1',
  TIER_2: 'TIER_2',
  TIER_3: 'TIER_3',
  TIER_4: 'TIER_4',
  TIER_1_V3: 'TIER_1_V3',
  TIER_2_V3: 'TIER_2_V3',
  TIER_3_V3: 'TIER_3_V3',
  TIER_4_V3: 'TIER_4_V3',
  TIER_5_V3: 'TIER_5_V3',
  TIER_6_V3: 'TIER_6_V3',
  TIER_7_V3: 'TIER_7_V3',
}

export const enumCompanyValidationDomainType = {
  SHOPIFY: 'SHOPIFY',
  AMAZON: 'AMAZON',
  INVENTORY: 'INVENTORY',
  ACCRUALS: 'ACCRUALS',
  STRIPE: 'STRIPE',
  LOANS: 'LOANS',
  EQUITY: 'EQUITY',
  PAYMENTS: 'PAYMENTS',
  SALES: 'SALES',
  COMPANY_AFFILIATES: 'COMPANY_AFFILIATES',
  BANKS: 'BANKS',
  BANK_TRANSACTIONS: 'BANK_TRANSACTIONS',
  BILLS: 'BILLS',
  AR: 'AR',
  MONEY_IN_TRANSIT: 'MONEY_IN_TRANSIT',
  GENERAL: 'GENERAL',
  ORDERS: 'ORDERS',
  PAYROLL: 'PAYROLL',
  TIK_TOK: 'TIK_TOK',
}

export const enumCompanyValidationMetricMode = {
  DIFF: 'DIFF',
  INFO: 'INFO',
}

export const enumCompanyValidationMetricName = {
  INTERNAL_DIFF: 'INTERNAL_DIFF',
  USER_FACING_DIFF: 'USER_FACING_DIFF',
  QUANTITY_DIFF: 'QUANTITY_DIFF',
  COST_DIFF: 'COST_DIFF',
  BUSINESS_EVENTS_DIFF: 'BUSINESS_EVENTS_DIFF',
  BS_DIFF: 'BS_DIFF',
  ACCRUALS_CLEARING_ACCOUNT: 'ACCRUALS_CLEARING_ACCOUNT',
  GROSS_SALES_DIFF: 'GROSS_SALES_DIFF',
  NET_SALES_DIFF: 'NET_SALES_DIFF',
  TOTAL_SALES_DIFF: 'TOTAL_SALES_DIFF',
  ORDERS_RECONCILIATION_STATUS: 'ORDERS_RECONCILIATION_STATUS',
  UDF_DIFF: 'UDF_DIFF',
  UDF_ON_HOLD_DIFF: 'UDF_ON_HOLD_DIFF',
  LOANS_OUTSTANDING_AMOUNT_NEG: 'LOANS_OUTSTANDING_AMOUNT_NEG',
  CLEARING_ACCOUNT: 'CLEARING_ACCOUNT',
  HOLDINGS_DIFF: 'HOLDINGS_DIFF',
  ACCOUNT_RECEIVABLE_DIFF: 'ACCOUNT_RECEIVABLE_DIFF',
  CLEARING_ACCOUNT_INVOICES_DIFF: 'CLEARING_ACCOUNT_INVOICES_DIFF',
  CLEARING_ACCOUNT_INVOICE_PAYMENTS_DIFF:
    'CLEARING_ACCOUNT_INVOICE_PAYMENTS_DIFF',
  UNCLEARED_INVOICES_BALANCE_DIFF: 'UNCLEARED_INVOICES_BALANCE_DIFF',
  PAYPAL_INVOICES_DIFF: 'PAYPAL_INVOICES_DIFF',
  PROFIT_AND_LOSS_DIFF: 'PROFIT_AND_LOSS_DIFF',
  RETAINED_EARNINGS_BALANCE_DIFF: 'RETAINED_EARNINGS_BALANCE_DIFF',
  STRIPE_INVOICES_DIFF: 'STRIPE_INVOICES_DIFF',
  LOANS_ACTION_REQUIRED_COUNT: 'LOANS_ACTION_REQUIRED_COUNT',
  LOANS_OUTSTANDING_AMOUNT_DIFF: 'LOANS_OUTSTANDING_AMOUNT_DIFF',
  LOANS_OUTSTANDING_AMOUNT_VS_FEES: 'LOANS_OUTSTANDING_AMOUNT_VS_FEES',
  LOANS_OUTSTANDING_AMOUNT_ZERO_BEFORE_NEW_LOAN:
    'LOANS_OUTSTANDING_AMOUNT_ZERO_BEFORE_NEW_LOAN',
  GIFTCARDS_DIFF: 'GIFTCARDS_DIFF',
  CLEARING_ACCOUNT_BILL_PAYMENTS_DIFF: 'CLEARING_ACCOUNT_BILL_PAYMENTS_DIFF',
  ACCOUNT_PAYABLE_DIFF: 'ACCOUNT_PAYABLE_DIFF',
  PLATFORM_PAYABLE_DIFF: 'PLATFORM_PAYABLE_DIFF',
  ACCRUED_INTEREST_DIFF: 'ACCRUED_INTEREST_DIFF',
  LOAN_PAYABLE_DIFF: 'LOAN_PAYABLE_DIFF',
  SETTLE_TOTAL_DIFF: 'SETTLE_TOTAL_DIFF',
  SETTLE_NUMBER_DIFF: 'SETTLE_NUMBER_DIFF',
  SETTLE_LOAN_PAYABLE_DIFF: 'SETTLE_LOAN_PAYABLE_DIFF',
  SETTLE_VENDOR_PAYABLE_DIFF: 'SETTLE_VENDOR_PAYABLE_DIFF',
  BILL_COM_TOTAL_DIFF: 'BILL_COM_TOTAL_DIFF',
  BILL_COM_NUMBER_DIFF: 'BILL_COM_NUMBER_DIFF',
  BILL_COM_VENDOR_PAYABLE_DIFF: 'BILL_COM_VENDOR_PAYABLE_DIFF',
  AR_UNMATCHED_RATE: 'AR_UNMATCHED_RATE',
  AR_DIFF: 'AR_DIFF',
  MONEY_IN_TRANSIT_DIFF: 'MONEY_IN_TRANSIT_DIFF',
  AR_POTENTIAL_UNMATCHED_RATE: 'AR_POTENTIAL_UNMATCHED_RATE',
  GENERAL_CLEARING_ACCOUNT: 'GENERAL_CLEARING_ACCOUNT',
  INVENTORY_CLEARING_ACCOUNT: 'INVENTORY_CLEARING_ACCOUNT',
  LOANS_CLEARING_ACCOUNT: 'LOANS_CLEARING_ACCOUNT',
  ORDERS_CLEARING_ACCOUNT: 'ORDERS_CLEARING_ACCOUNT',
  PAYROLL_CLEARING_ACCOUNT: 'PAYROLL_CLEARING_ACCOUNT',
  PAYMENTS_CLEARING_ACCOUNT: 'PAYMENTS_CLEARING_ACCOUNT',
  TOTAL_BANK_ACCOUNTS: 'TOTAL_BANK_ACCOUNTS',
  BANK_ACCOUNT_ISSUE: 'BANK_ACCOUNT_ISSUE',
  AR_CASH_DIFF: 'AR_CASH_DIFF',
  MONEY_IN_OUT_DIFF: 'MONEY_IN_OUT_DIFF',
  DEFERRED_REVENUE_DIFF: 'DEFERRED_REVENUE_DIFF',
  INVENTORY_FULFILLMENTS_AFTER_LOCK: 'INVENTORY_FULFILLMENTS_AFTER_LOCK',
}

export const enumCompanyValidationStatus = {
  PASS: 'PASS',
  FAIL: 'FAIL',
  NA: 'NA',
}

export const enumCompanyValidationType = {
  INVENTORY_BIG: 'INVENTORY_BIG',
  INVENTORY_VENDORS: 'INVENTORY_VENDORS',
  INVENTORY_FIFO: 'INVENTORY_FIFO',
  INVENTORY_NO_UNIT: 'INVENTORY_NO_UNIT',
  AMAZON_PRODUCTS: 'AMAZON_PRODUCTS',
  AMAZON_INVENTORY_LEDGER: 'AMAZON_INVENTORY_LEDGER',
  SHOPIFY_PRODUCTS: 'SHOPIFY_PRODUCTS',
  ORDERS_RECONCILIATION: 'ORDERS_RECONCILIATION',
  DEFERRED_REVENUE: 'DEFERRED_REVENUE',
  ACCRUALS_ALL_ENTITIES: 'ACCRUALS_ALL_ENTITIES',
  INVENTORY_PURCHASES: 'INVENTORY_PURCHASES',
  STRIPE_UDF: 'STRIPE_UDF',
  LOANS_OUTSTANDING_AMOUNT: 'LOANS_OUTSTANDING_AMOUNT',
  EQUITY_ACCOUNTS: 'EQUITY_ACCOUNTS',
  EQUITY_ENTITIES: 'EQUITY_ENTITIES',
  EQUITY_CLEARING_ACCOUNT: 'EQUITY_CLEARING_ACCOUNT',
  EQUITY_HOLDINGS: 'EQUITY_HOLDINGS',
  EQUITY_HOLDERS: 'EQUITY_HOLDERS',
  KLARNA_UDF: 'KLARNA_UDF',
  INVOICES: 'INVOICES',
  CLEARING_ACCOUNT: 'CLEARING_ACCOUNT',
  COMPANY_AFFILIATES_CLEARING_ACCOUNT: 'COMPANY_AFFILIATES_CLEARING_ACCOUNT',
  LOANS_ACTION_REQUIRED: 'LOANS_ACTION_REQUIRED',
  LOANS_AUTOMATION: 'LOANS_AUTOMATION',
  SHOPIFY_GIFTCARDS: 'SHOPIFY_GIFTCARDS',
  BANKS_BALANCE: 'BANKS_BALANCE',
  BILLS: 'BILLS',
  SETTLE: 'SETTLE',
  BILL_COM: 'BILL_COM',
  AR: 'AR',
  MONEY_IN_TRANSIT: 'MONEY_IN_TRANSIT',
  AR_CASH: 'AR_CASH',
  MONEY_IN_OUT: 'MONEY_IN_OUT',
  PHYSICAL_COUNT: 'PHYSICAL_COUNT',
  TIK_TOK_UDF: 'TIK_TOK_UDF',
}

export const enumCostType = {
  LandedCost: 'LandedCost',
  Indirect: 'Indirect',
  Direct: 'Direct',
}

export const enumCurrencyCode = {
  AED: 'AED',
  AFN: 'AFN',
  ALL: 'ALL',
  AMD: 'AMD',
  ANG: 'ANG',
  AOA: 'AOA',
  ARS: 'ARS',
  AUD: 'AUD',
  AWG: 'AWG',
  AZN: 'AZN',
  BAM: 'BAM',
  BBD: 'BBD',
  BDT: 'BDT',
  BGN: 'BGN',
  BHD: 'BHD',
  BIF: 'BIF',
  BMD: 'BMD',
  BND: 'BND',
  BOB: 'BOB',
  BRL: 'BRL',
  BSD: 'BSD',
  BTN: 'BTN',
  BWP: 'BWP',
  BYN: 'BYN',
  BZD: 'BZD',
  CAD: 'CAD',
  CDF: 'CDF',
  CHF: 'CHF',
  CLP: 'CLP',
  CNY: 'CNY',
  COP: 'COP',
  CRC: 'CRC',
  CUC: 'CUC',
  CUP: 'CUP',
  CVE: 'CVE',
  CZK: 'CZK',
  DJF: 'DJF',
  DKK: 'DKK',
  DOP: 'DOP',
  DZD: 'DZD',
  EGP: 'EGP',
  ERN: 'ERN',
  ETB: 'ETB',
  EUR: 'EUR',
  FJD: 'FJD',
  FKP: 'FKP',
  GBP: 'GBP',
  GEL: 'GEL',
  GHS: 'GHS',
  GIP: 'GIP',
  GMD: 'GMD',
  GNF: 'GNF',
  GTQ: 'GTQ',
  GYD: 'GYD',
  HKD: 'HKD',
  HNL: 'HNL',
  HRK: 'HRK',
  HTG: 'HTG',
  HUF: 'HUF',
  IDR: 'IDR',
  ILS: 'ILS',
  INR: 'INR',
  IQD: 'IQD',
  IRR: 'IRR',
  ISK: 'ISK',
  JMD: 'JMD',
  JOD: 'JOD',
  JPY: 'JPY',
  KES: 'KES',
  KGS: 'KGS',
  KHR: 'KHR',
  KMF: 'KMF',
  KPW: 'KPW',
  KRW: 'KRW',
  KWD: 'KWD',
  KYD: 'KYD',
  KZT: 'KZT',
  LAK: 'LAK',
  LBP: 'LBP',
  LKR: 'LKR',
  LRD: 'LRD',
  LSL: 'LSL',
  LYD: 'LYD',
  MAD: 'MAD',
  MDL: 'MDL',
  MGA: 'MGA',
  MKD: 'MKD',
  MMK: 'MMK',
  MNT: 'MNT',
  MOP: 'MOP',
  MRU: 'MRU',
  MUR: 'MUR',
  MVR: 'MVR',
  MWK: 'MWK',
  MXN: 'MXN',
  MYR: 'MYR',
  MZN: 'MZN',
  NAD: 'NAD',
  NGN: 'NGN',
  NIO: 'NIO',
  NOK: 'NOK',
  NPR: 'NPR',
  NZD: 'NZD',
  OMR: 'OMR',
  PAB: 'PAB',
  PEN: 'PEN',
  PGK: 'PGK',
  PHP: 'PHP',
  PKR: 'PKR',
  PLN: 'PLN',
  PYG: 'PYG',
  QAR: 'QAR',
  RON: 'RON',
  RSD: 'RSD',
  RUB: 'RUB',
  RWF: 'RWF',
  SAR: 'SAR',
  SBD: 'SBD',
  SCR: 'SCR',
  SDG: 'SDG',
  SEK: 'SEK',
  SGD: 'SGD',
  SHP: 'SHP',
  SLL: 'SLL',
  SOS: 'SOS',
  SRD: 'SRD',
  SSP: 'SSP',
  STN: 'STN',
  SVC: 'SVC',
  SYP: 'SYP',
  SZL: 'SZL',
  THB: 'THB',
  TJS: 'TJS',
  TMT: 'TMT',
  TND: 'TND',
  TOP: 'TOP',
  TRY: 'TRY',
  TTD: 'TTD',
  TWD: 'TWD',
  TZS: 'TZS',
  UAH: 'UAH',
  UGX: 'UGX',
  USD: 'USD',
  UYU: 'UYU',
  UZS: 'UZS',
  VES: 'VES',
  VND: 'VND',
  VUV: 'VUV',
  WST: 'WST',
  XAF: 'XAF',
  XCD: 'XCD',
  XOF: 'XOF',
  XPF: 'XPF',
  YER: 'YER',
  ZAR: 'ZAR',
  ZMW: 'ZMW',
  ZWL: 'ZWL',
}

export const enumCustomerSelectedAccountingMethod = {
  ACCRUAL: 'ACCRUAL',
  CASH: 'CASH',
  MODIFIED_CASH: 'MODIFIED_CASH',
}

export const enumCustomerSource = {
  BILL_COM: 'BILL_COM',
  PAYPAL: 'PAYPAL',
  STRIPE: 'STRIPE',
  FINALOOP_INVOICES: 'FINALOOP_INVOICES',
  QUICKBOOKS: 'QUICKBOOKS',
  SPS_COMMERCE: 'SPS_COMMERCE',
  QUICKBOOKS_INVOICES: 'QUICKBOOKS_INVOICES',
  NU_ORDER_INVOICES: 'NU_ORDER_INVOICES',
}

export const enumDepreciationMethod = {
  STRAIGHT_LINE: 'STRAIGHT_LINE',
  DECLINING_BALANCE: 'DECLINING_BALANCE',
}

export const enumDiscountType = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED_AMOUNT: 'FIXED_AMOUNT',
}

export const enumDisputeOutcome = {
  RESOLVED: 'RESOLVED',
  REFUNDED: 'REFUNDED',
  CHARGEBACK: 'CHARGEBACK',
}

export const enumDropshippingModeType = {
  INCIDENTAL: 'INCIDENTAL',
  NON_INCIDENTAL: 'NON_INCIDENTAL',
}

export const enumDuplicateCheckResult = {
  DUPLICATE: 'DUPLICATE',
  NOT_DUPLICATE: 'NOT_DUPLICATE',
}

export const enumEarlyRepaymentDiscountPeriodType = {
  MONTH: 'MONTH',
  DAY: 'DAY',
  PAYMENT: 'PAYMENT',
}

export const enumEquityEventShareType = {
  COMMON_STOCK: 'COMMON_STOCK',
  PREFERRED: 'PREFERRED',
  SAFE: 'SAFE',
}

export const enumEstimatedProjectedRevenue = {
  ZERO_TO_TWO_HUNDRED_THOUSAND: 'ZERO_TO_TWO_HUNDRED_THOUSAND',
  ZERO_TO_HALF_A_MILLION: 'ZERO_TO_HALF_A_MILLION',
  TWO_HUNDRED_THOUSAND_TO_FIVE_HUNDRED_THOUSAND:
    'TWO_HUNDRED_THOUSAND_TO_FIVE_HUNDRED_THOUSAND',
  TWO_HUNDRED_THOUSAND_TO_ONE_MILLION: 'TWO_HUNDRED_THOUSAND_TO_ONE_MILLION',
  FIVE_HUNDRED_THOUSAND_TO_THREE_MILLION:
    'FIVE_HUNDRED_THOUSAND_TO_THREE_MILLION',
  HALF_A_MILLION_TO_ONE_AND_A_HALF_MILLION:
    'HALF_A_MILLION_TO_ONE_AND_A_HALF_MILLION',
  ONE_MILLION_TO_FIVE_MILLION: 'ONE_MILLION_TO_FIVE_MILLION',
  ONE_AND_A_HALF_TO_TEN_MILLION: 'ONE_AND_A_HALF_TO_TEN_MILLION',
  THREE_MILLION_TO_TEN_MILLION: 'THREE_MILLION_TO_TEN_MILLION',
  FIVE_MILLION_TO_TEN_MILLION: 'FIVE_MILLION_TO_TEN_MILLION',
  TEN_TO_FIFTY_MILLION: 'TEN_TO_FIFTY_MILLION',
  ABOVE_TEN_MILLION: 'ABOVE_TEN_MILLION',
  ABOVE_FIFTY_MILLION: 'ABOVE_FIFTY_MILLION',
}

export const enumExportedReportsLogsSortBy = {
  createdAt: 'createdAt',
  email: 'email',
}

export const enumExportStatus = {
  STARTING: 'STARTING',
  IN_PROGRESS: 'IN_PROGRESS',
  FAILURE: 'FAILURE',
  SUCCESS: 'SUCCESS',
  PARTIAL_SUCCESS: 'PARTIAL_SUCCESS',
  ERROR: 'ERROR',
}

export const enumFeature = {
  CATCHUP: 'CATCHUP',
  SUBSCRIPTION: 'SUBSCRIPTION',
}

export const enumFileType = {
  EXCEL: 'EXCEL',
}

export const enumFileUploadSource = {
  BANK_TRANSACTIONS_ATTACHMENT: 'BANK_TRANSACTIONS_ATTACHMENT',
  TAX_1099: 'TAX_1099',
  INVENTORY: 'INVENTORY',
  VALIDATION_DATA: 'VALIDATION_DATA',
  WORKSHEET: 'WORKSHEET',
  LOANS: 'LOANS',
  ORDERS: 'ORDERS',
  GIFT_CARDS: 'GIFT_CARDS',
  YEAR_END: 'YEAR_END',
  REPORTS: 'REPORTS',
  BALANCE_SHEET_HUB: 'BALANCE_SHEET_HUB',
  INVOICES: 'INVOICES',
}

export const enumFilterableBankStatementRequestTypes = {
  OPENING: 'OPENING',
  CLOSING: 'CLOSING',
  ONGOING: 'ONGOING',
  RECURRING_CSV: 'RECURRING_CSV',
  BULK_PDF: 'BULK_PDF',
  MISSING_TXNS: 'MISSING_TXNS',
  ONE_TIME_RECONCILIATION: 'ONE_TIME_RECONCILIATION',
  HISTORICAL_GAP: 'HISTORICAL_GAP',
  ACCESS_REMOVED: 'ACCESS_REMOVED',
}

export const enumFilterOperator = {
  IN: 'IN',
  NOTIN: 'NOTIN',
}

export const enumFinancedPaymentInstallmentStatus = {
  pending_approval: 'pending_approval',
  scheduled: 'scheduled',
  initiated: 'initiated',
  completed: 'completed',
  failed: 'failed',
  canceled: 'canceled',
  refunded: 'refunded',
}

export const enumFinancialReportingStatus = {
  COGS_ONLY: 'COGS_ONLY',
  SALES_ONLY: 'SALES_ONLY',
  COGS_AND_SALES: 'COGS_AND_SALES',
  EXCLUDED: 'EXCLUDED',
  GIVEAWAY: 'GIVEAWAY',
}

export const enumFinancialReportingStatusSource = {
  SALES_CHANNEL_CONFIGURATION: 'SALES_CHANNEL_CONFIGURATION',
  MARKED_BY_USER: 'MARKED_BY_USER',
}

export const enumFulfillmentChannel = {
  SELLER: 'SELLER',
  PLATFORM: 'PLATFORM',
}

export const enumFulfillmentCostType = {
  PICK_AND_PACK: 'PICK_AND_PACK',
}

export const enumFulfillmentMethodType = {
  AUTOMATIC: 'AUTOMATIC',
  INTEGRATION: 'INTEGRATION',
}

export const enumFulfillmentStatus = {
  UNFULFILLED: 'UNFULFILLED',
  PARTIALLY_FULFILLED: 'PARTIALLY_FULFILLED',
  FULFILLED: 'FULFILLED',
}

export const enumGetBankStatementRequestsDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
}

export const enumGetBankStatementRequestsSortType = {
  COMPANY_NAME: 'COMPANY_NAME',
  TIER: 'TIER',
  STATUS: 'STATUS',
  LAST_UPDATED_AT: 'LAST_UPDATED_AT',
  COMPLETED_AT: 'COMPLETED_AT',
}

export const enumGetCogsBreakdownSortField = {
  SKU: 'SKU',
  DISPLAY_NAME: 'DISPLAY_NAME',
  UNITS: 'UNITS',
  TOTAL_LANDED: 'TOTAL_LANDED',
  TOTAL_DIRECT: 'TOTAL_DIRECT',
  TOTAL_VENDOR_FEES: 'TOTAL_VENDOR_FEES',
  TOTAL_DUTIES_AND_TAX: 'TOTAL_DUTIES_AND_TAX',
  TOTAL_CUSTOM_FEES_AND_SERVICES: 'TOTAL_CUSTOM_FEES_AND_SERVICES',
  TOTAL_INSURANCE: 'TOTAL_INSURANCE',
  TOTAL_PRODUCTION_COST: 'TOTAL_PRODUCTION_COST',
  TOTAL_DISCOUNT: 'TOTAL_DISCOUNT',
  TOTAL_SHIPPING: 'TOTAL_SHIPPING',
  TOTAL_PALLET_COSTS: 'TOTAL_PALLET_COSTS',
  TOTAL_SHIPPING_SURCHARGE: 'TOTAL_SHIPPING_SURCHARGE',
  TOTAL_OTHER_INVENTORY_ADJUSTMENTS: 'TOTAL_OTHER_INVENTORY_ADJUSTMENTS',
  TOTAL_PRODUCTION_LABOR_COST: 'TOTAL_PRODUCTION_LABOR_COST',
  AVG_COST_PER_UNIT_LANDED: 'AVG_COST_PER_UNIT_LANDED',
  AVG_COST_PER_UNIT_DIRECT: 'AVG_COST_PER_UNIT_DIRECT',
  AVG_COST_PER_UNIT_VENDOR_FEES: 'AVG_COST_PER_UNIT_VENDOR_FEES',
  AVG_COST_PER_UNIT_DUTIES_AND_TAX: 'AVG_COST_PER_UNIT_DUTIES_AND_TAX',
  AVG_COST_PER_UNIT_CUSTOM_FEES_AND_SERVICES:
    'AVG_COST_PER_UNIT_CUSTOM_FEES_AND_SERVICES',
  AVG_COST_PER_UNIT_INSURANCE: 'AVG_COST_PER_UNIT_INSURANCE',
  AVG_COST_PER_UNIT_PRODUCTION_COST: 'AVG_COST_PER_UNIT_PRODUCTION_COST',
  AVG_COST_PER_UNIT_DISCOUNT: 'AVG_COST_PER_UNIT_DISCOUNT',
  AVG_COST_PER_UNIT_SHIPPING: 'AVG_COST_PER_UNIT_SHIPPING',
  AVG_COST_PER_UNIT_PALLET_COSTS: 'AVG_COST_PER_UNIT_PALLET_COSTS',
  AVG_COST_PER_UNIT_SHIPPING_SURCHARGE: 'AVG_COST_PER_UNIT_SHIPPING_SURCHARGE',
  AVG_COST_PER_UNIT_OTHER_INVENTORY_ADJUSTMENTS:
    'AVG_COST_PER_UNIT_OTHER_INVENTORY_ADJUSTMENTS',
  AVG_COST_PER_UNIT_PRODUCTION_LABOR_COST:
    'AVG_COST_PER_UNIT_PRODUCTION_LABOR_COST',
}

export const enumGetNoUnitsPhysicalCountProductQuantitiesSortField = {
  SKU: 'SKU',
  COST_PER_UNIT: 'COST_PER_UNIT',
  DISPLAY_NAME: 'DISPLAY_NAME',
  TOTAL_CLOSING_BALANCE: 'TOTAL_CLOSING_BALANCE',
  QUANTITY: 'QUANTITY',
}

export const enumGetOrdersSortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
}

export const enumGetOrdersSortType = {
  PLACED_DATE: 'PLACED_DATE',
  FIRST_PAYMENT_DATE: 'FIRST_PAYMENT_DATE',
  FIRST_REFUND_DATE: 'FIRST_REFUND_DATE',
  FIRST_FULFILLMENT_DATE: 'FIRST_FULFILLMENT_DATE',
  TOTAL: 'TOTAL',
  NET_SALES: 'NET_SALES',
  UNPAID_BALANCE: 'UNPAID_BALANCE',
  BALANCE: 'BALANCE',
}

export const enumGetPendingAdjustmentsSortField = {
  SKU: 'SKU',
  PRODUCT_DISPLAY_NAME: 'PRODUCT_DISPLAY_NAME',
  SOURCE: 'SOURCE',
  WAREHOUSE_NAME: 'WAREHOUSE_NAME',
  DATE: 'DATE',
  UNITS_SOLD: 'UNITS_SOLD',
  UNITS_RESTOCKED: 'UNITS_RESTOCKED',
  QUANTITY: 'QUANTITY',
}

export const enumGetPendingSalesDataAdjustmentsSortField = {
  SKU: 'SKU',
  PRODUCT_DISPLAY_NAME: 'PRODUCT_DISPLAY_NAME',
  SOURCE: 'SOURCE',
  WAREHOUSE_NAME: 'WAREHOUSE_NAME',
  DATE: 'DATE',
  UNITS_SOLD: 'UNITS_SOLD',
  UNITS_RESTOCKED: 'UNITS_RESTOCKED',
}

export const enumGetProductsSortField = {
  SKU: 'SKU',
  DISPLAY_NAME: 'DISPLAY_NAME',
  TOTAL_SOLD: 'TOTAL_SOLD',
  CURRENT_COST: 'CURRENT_COST',
  NET_DEPLETED: 'NET_DEPLETED',
  COST_PER_UNIT: 'COST_PER_UNIT',
  ON_HAND_COST: 'ON_HAND_COST',
  ON_HAND: 'ON_HAND',
  PURCHASED: 'PURCHASED',
  IN_TRANSIT: 'IN_TRANSIT',
  SOURCE: 'SOURCE',
  OPENING_BALANCE_QUANTITY: 'OPENING_BALANCE_QUANTITY',
  NEGATIVE_ON_HAND: 'NEGATIVE_ON_HAND',
}

export const enumGetSalesSortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
}

export const enumGetSalesSortType = {
  PLACED_DATE: 'PLACED_DATE',
  DISPLAY_NAME: 'DISPLAY_NAME',
  CUSTOMER_NAME: 'CUSTOMER_NAME',
  SOURCE: 'SOURCE',
  TOTAL: 'TOTAL',
  TOTAL_BEFORE_TAXES: 'TOTAL_BEFORE_TAXES',
  BALANCE: 'BALANCE',
  DUE_DATE: 'DUE_DATE',
}

export const enumGetUnitsTrackingPhysicalCountProductQuantitiesSortField = {
  SKU: 'SKU',
  AVG_COST: 'AVG_COST',
  DISPLAY_NAME: 'DISPLAY_NAME',
  UNITS_ON_HAND: 'UNITS_ON_HAND',
  ADJUSTMENT: 'ADJUSTMENT',
  TOTAL_ADJUSTMENT: 'TOTAL_ADJUSTMENT',
  QUANTITY: 'QUANTITY',
}

export const enumGiftCardIssueMethod = {
  PURCHASED: 'PURCHASED',
  MANUALLY_ISSUED: 'MANUALLY_ISSUED',
}

export const enumGiftCardSortKeys = {
  STATUS: 'STATUS',
  INITIAL_BALANCE: 'INITIAL_BALANCE',
  BALANCE_AS_OF: 'BALANCE_AS_OF',
  CURRENT_BALANCE: 'CURRENT_BALANCE',
  ISSUE_DATE: 'ISSUE_DATE',
  DEACTIVATION_DATE: 'DEACTIVATION_DATE',
  EXPIRATION_DATE: 'EXPIRATION_DATE',
  DISABLE_DATE: 'DISABLE_DATE',
}

export const enumGiftCardsSortDirection = {
  ASCENDING: 'ASCENDING',
  DESCENDING: 'DESCENDING',
}

export const enumGiftCardStatus = {
  ACTIVE: 'ACTIVE',
  PARTIALLY_REDEEMED: 'PARTIALLY_REDEEMED',
  REDEEMED: 'REDEEMED',
  DEACTIVATED: 'DEACTIVATED',
  EXPIRED: 'EXPIRED',
}

export const enumHolderStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
}

export const enumHolderTransactionType = {
  CONTRIBUTION: 'CONTRIBUTION',
  DISTRIBUTION: 'DISTRIBUTION',
  REDEMPTION: 'REDEMPTION',
}

export const enumHubItemState = {
  INACTIVE: 'INACTIVE',
  OPEN: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  CLOSED: 'CLOSED',
}

export const enumHubState = {
  INACTIVE: 'INACTIVE',
  OPEN: 'OPEN',
  INITIAL_PROCESSING: 'INITIAL_PROCESSING',
  AWAITING_USER_FEEDBACK: 'AWAITING_USER_FEEDBACK',
  FOLLOW_UP_PROCESSING: 'FOLLOW_UP_PROCESSING',
  READY: 'READY',
  NA: 'NA',
}

export const enumHubUpdaterType = {
  USER: 'USER',
  SYSTEM: 'SYSTEM',
  OPS: 'OPS',
}

export const enumHubUpdaterTypeInput = {
  USER: 'USER',
  OPS: 'OPS',
}

export const enumIndirectLineItemType = {
  SHIPPING: 'SHIPPING',
  GENERAL: 'GENERAL',
  VENDOR_FEES: 'VENDOR_FEES',
  DUTIES_AND_TAX: 'DUTIES_AND_TAX',
  CUSTOM_FEES_AND_SERVICES: 'CUSTOM_FEES_AND_SERVICES',
  INSURANCE: 'INSURANCE',
  PRODUCTION_COSTS: 'PRODUCTION_COSTS',
  DISCOUNT: 'DISCOUNT',
  PALLET_COSTS: 'PALLET_COSTS',
  SHIPPING_SURCHARGE: 'SHIPPING_SURCHARGE',
  OTHER_INVENTORY_ADJUSTMENTS: 'OTHER_INVENTORY_ADJUSTMENTS',
  PRODUCTION_LABOR_COSTS: 'PRODUCTION_LABOR_COSTS',
  OTHER: 'OTHER',
}

export const enumIndividualSkusSortField = {
  DATE: 'DATE',
  SALES: 'SALES',
  DISCOUNTS: 'DISCOUNTS',
  COGS: 'COGS',
  PROFIT: 'PROFIT',
  MARGIN: 'MARGIN',
  REFUNDS: 'REFUNDS',
  UNITS_SOLD: 'UNITS_SOLD',
  UNITS_REFUNDED: 'UNITS_REFUNDED',
}

export const enumInstitutionMappingSourceType = {
  PLAID: 'PLAID',
  QUICKBOOKS: 'QUICKBOOKS',
  QUICKBOOKS_BANKS: 'QUICKBOOKS_BANKS',
}

export const enumInstitutionProviders = {
  PLAID: 'PLAID',
  PAYPAL: 'PAYPAL',
  RAMP: 'RAMP',
  MANUAL: 'MANUAL',
}

export const enumIntegrationConnectionType = {
  PAYMENT_PROCESSOR: 'PAYMENT_PROCESSOR',
  MARKETPLACE: 'MARKETPLACE',
}

export const enumIntegrationSource = {
  PAYPAL: 'PAYPAL',
  STRIPE: 'STRIPE',
  QUICKBOOKS: 'QUICKBOOKS',
  SPS_COMMERCE: 'SPS_COMMERCE',
  QUICKBOOKS_INVOICES: 'QUICKBOOKS_INVOICES',
  NU_ORDER_INVOICES: 'NU_ORDER_INVOICES',
  FINALOOP_INVOICES: 'FINALOOP_INVOICES',
}

export const enumIntegrationTransferPairedEntityType = {
  COMPANY_AFFILIATE: 'COMPANY_AFFILIATE',
  BANK_TRANSACTION: 'BANK_TRANSACTION',
  RELATED_PARTY: 'RELATED_PARTY',
}

export const enumIntegrationTransferType = {
  PAYOUT: 'PAYOUT',
  TOPUP: 'TOPUP',
}

export const enumIntegrationTransferTypeV2 = {
  FROM_INTEGRATION: 'FROM_INTEGRATION',
  TO_INTEGRATION: 'TO_INTEGRATION',
}

export const enumIntegrationType = {
  AFTERPAY: 'AFTERPAY',
  AMAZON: 'AMAZON',
  AMAZON_PAY: 'AMAZON_PAY',
  BILL_COM: 'BILL_COM',
  EBAY: 'EBAY',
  ETSY: 'ETSY',
  FACEBOOK_ADS: 'FACEBOOK_ADS',
  GOOGLE_ADS: 'GOOGLE_ADS',
  PAYPAL: 'PAYPAL',
  PLAID: 'PLAID',
  QUICKBOOKS: 'QUICKBOOKS',
  SHOPIFY: 'SHOPIFY',
  SHOP_PAY: 'SHOP_PAY',
  STRIPE: 'STRIPE',
  WALMART: 'WALMART',
  FINALOOP_BANK_TRANSACTIONS_UPLOAD: 'FINALOOP_BANK_TRANSACTIONS_UPLOAD',
  FINALOOP_BALANCE_TRANSACTIONS: 'FINALOOP_BALANCE_TRANSACTIONS',
  FINALOOP_BILLS: 'FINALOOP_BILLS',
  FINALOOP_INVOICES: 'FINALOOP_INVOICES',
  FINALOOP_INVENTORY: 'FINALOOP_INVENTORY',
  FINALOOP_INTERNAL: 'FINALOOP_INTERNAL',
  FINALOOP_PAYMENTS: 'FINALOOP_PAYMENTS',
  FINALOOP_TRANSACTIONS: 'FINALOOP_TRANSACTIONS',
  FINALOOP_TRANSACTIONS_MACHINE: 'FINALOOP_TRANSACTIONS_MACHINE',
  FINALOOP_BANK_ACCOUNT_VALIDATIONS: 'FINALOOP_BANK_ACCOUNT_VALIDATIONS',
  FINALOOP_COMPANY_AFFILIATE_BALANCES: 'FINALOOP_COMPANY_AFFILIATE_BALANCES',
  QUICKBOOKS_BANKS: 'QUICKBOOKS_BANKS',
  REPORTED_BUSINESS_BANK_TRANSACTIONS: 'REPORTED_BUSINESS_BANK_TRANSACTIONS',
  SHADOW_QUICKBOOKS: 'SHADOW_QUICKBOOKS',
  SHOPIFY_ORDERS: 'SHOPIFY_ORDERS',
  SHOPIFY_PRODUCTS: 'SHOPIFY_PRODUCTS',
  TEST: 'TEST',
  USER: 'USER',
  USER_PASSWORD: 'USER_PASSWORD',
  AFFIRM: 'AFFIRM',
  ALMA: 'ALMA',
  AUTHORIZE_NET: 'AUTHORIZE_NET',
  BLACKCART: 'BLACKCART',
  BANKFUL: 'BANKFUL',
  BRAINTREE: 'BRAINTREE',
  CLEARCO: 'CLEARCO',
  CLEARPAY: 'CLEARPAY',
  FAIRE: 'FAIRE',
  PARKER: 'PARKER',
  KLARNA: 'KLARNA',
  KLICKLY: 'KLICKLY',
  SETTLE: 'SETTLE',
  SEZZLE: 'SEZZLE',
  SPS_COMMERCE: 'SPS_COMMERCE',
  QUICKBOOKS_PAYMENTS: 'QUICKBOOKS_PAYMENTS',
  SQUARE: 'SQUARE',
  WOOCOMMERCE: 'WOOCOMMERCE',
  FACEBOOK: 'FACEBOOK',
  ZIP_CO: 'ZIP_CO',
  SPLITIT: 'SPLITIT',
  BREAD_PAY: 'BREAD_PAY',
  GLOBAL_E: 'GLOBAL_E',
  GUSTO: 'GUSTO',
  SNACK_MAGIC: 'SNACK_MAGIC',
  POSTAL: 'POSTAL',
  CORPORATE_GIFT: 'CORPORATE_GIFT',
  CAROO: 'CAROO',
  CARRO: 'CARRO',
  RAMP: 'RAMP',
  RAMP_PUBLIC_API: 'RAMP_PUBLIC_API',
  STRIPE_FINANCIAL_CONNECTIONS: 'STRIPE_FINANCIAL_CONNECTIONS',
  MX: 'MX',
  REVOLUT: 'REVOLUT',
  OPEN_PATH: 'OPEN_PATH',
  OPEN_NOD: 'OPEN_NOD',
  RETURNLY: 'RETURNLY',
  COINBASE: 'COINBASE',
  TRUE_MED: 'TRUE_MED',
  PAYONEER: 'PAYONEER',
  AIRWALLEX: 'AIRWALLEX',
  LEAP_RETAIL: 'LEAP_RETAIL',
  TWINT: 'TWINT',
  MIRAKL: 'MIRAKL',
  CATCH: 'CATCH',
  PARTIAL_LY: 'PARTIAL_LY',
  TIK_TOK: 'TIK_TOK',
  BLOOM: 'BLOOM',
  TRACKSTAR: 'TRACKSTAR',
  QUICKBOOKS_INVOICES: 'QUICKBOOKS_INVOICES',
  NU_ORDER_INVOICES: 'NU_ORDER_INVOICES',
}

export const enumInventoryPaymentGroupsSortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
}

export const enumInventoryPaymentGroupsSortType = {
  POSTED_AT: 'POSTED_AT',
}

export const enumInventoryPurchaseCategoryName = {
  CONSIGNMENT: 'CONSIGNMENT',
  DROPSHIPPING: 'DROPSHIPPING',
  DEAD_INVENTORY: 'DEAD_INVENTORY',
  FINISHED_PRODUCTS: 'FINISHED_PRODUCTS',
  OTHER_INVENTORY_INDIRECT_COSTS: 'OTHER_INVENTORY_INDIRECT_COSTS',
  PACKAGING_MATERIALS: 'PACKAGING_MATERIALS',
  PRODUCTION_COSTS: 'PRODUCTION_COSTS',
  PRODUCTION_LABOR_COSTS: 'PRODUCTION_LABOR_COSTS',
  SHIPPING_AND_FREIGHT_IN: 'SHIPPING_AND_FREIGHT_IN',
  SUPPLIES_AND_MATERIALS: 'SUPPLIES_AND_MATERIALS',
  VENDOR_FEES: 'VENDOR_FEES',
  DUTIES_AND_TAX: 'DUTIES_AND_TAX',
  CUSTOM_FEES_AND_SERVICES: 'CUSTOM_FEES_AND_SERVICES',
  INVENTORY_INSURANCE: 'INVENTORY_INSURANCE',
  SHIPPING_SURCHARGE: 'SHIPPING_SURCHARGE',
  PALLET_COSTS: 'PALLET_COSTS',
  PRODUCT_DONATIONS: 'PRODUCT_DONATIONS',
  PRODUCT_GIVEAWAYS: 'PRODUCT_GIVEAWAYS',
  WARRANTY_REIMBURSEMENT: 'WARRANTY_REIMBURSEMENT',
}

export const enumInventoryPurchaseDirection = {
  PURCHASE: 'PURCHASE',
  REFUND: 'REFUND',
}

export const enumInventoryPurchasePaymentStatus = {
  UNPAID: 'UNPAID',
  PARTIALLY_PAID: 'PARTIALLY_PAID',
  FULLY_PAID: 'FULLY_PAID',
}

export const enumInventoryPurchaseRuleApplyRuleOperation = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
}

export const enumInventoryPurchaseRuleCondition = {
  GREATER_THAN: 'GREATER_THAN',
  LESS_THAN: 'LESS_THAN',
}

export const enumInventoryPurchaseSource = {
  TRANSACTION: 'TRANSACTION',
  BILL: 'BILL',
  USER_INPUT: 'USER_INPUT',
  PAYROLL: 'PAYROLL',
  AMAZON_SHIPPING_IN: 'AMAZON_SHIPPING_IN',
  CONTRACTOR_PAYMENT: 'CONTRACTOR_PAYMENT',
}

export const enumInventoryPurchaseSourceCategory = {
  BILL: 'BILL',
  PURCHASE: 'PURCHASE',
}

export const enumInventoryPurchasesSortByField = {
  DATE: 'DATE',
  PAID_STATUS: 'PAID_STATUS',
}

export const enumInventoryPurchasesSortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
}

export const enumInventoryPurchaseStatus = {
  PENDING: 'PENDING',
  IN_PROCESS: 'IN_PROCESS',
  IN_TRANSIT: 'IN_TRANSIT',
  RECEIVED: 'RECEIVED',
}

export const enumInventoryPurchasesValidationStatus = {
  PASS: 'PASS',
  FAIL: 'FAIL',
}

export const enumInventoryPurchaseType = {
  PURCHASE: 'PURCHASE',
  INCIDENTAL: 'INCIDENTAL',
  ALLOCATED_RECIPES: 'ALLOCATED_RECIPES',
}

export const enumInventoryUsageType = {
  WAREHOUSE_TRANSFERS: 'WAREHOUSE_TRANSFERS',
  INVOICE_COGS: 'INVOICE_COGS',
  OTHER_INTEGRATION_SALES: 'OTHER_INTEGRATION_SALES',
  DROPSHIPPING: 'DROPSHIPPING',
}

export const enumInventoryVendorBillItemType = {
  BILL: 'BILL',
  INCIDENTAL: 'INCIDENTAL',
  PAYMENT: 'PAYMENT',
  CREDIT: 'CREDIT',
  ADJUSTMENT: 'ADJUSTMENT',
}

export const enumInventoryVendorRollingBalanceItemTypes = {
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  BILL: 'BILL',
  PAYMENT: 'PAYMENT',
  TRANSACTION: 'TRANSACTION',
  USER_INPUT: 'USER_INPUT',
  WAREHOUSE_TRANSFER: 'WAREHOUSE_TRANSFER',
  ASSEMBLY: 'ASSEMBLY',
}

export const enumInventoryVendorsSortField = {
  vendorName: 'vendorName',
  rollingBalance: 'rollingBalance',
}

export const enumInventoryYearEndMissionStatus = {
  OPEN: 'OPEN',
  REOPEN: 'REOPEN',
  COMPLETED: 'COMPLETED',
}

export const enumInventoryYearEndMissionsType = {
  PurchaseBasedOpeningBalance: 'PurchaseBasedOpeningBalance',
  PurchaseBasedPurchases: 'PurchaseBasedPurchases',
  PurchaseBasedClosingBalance: 'PurchaseBasedClosingBalance',
  SalesBasedOpeningBalance: 'SalesBasedOpeningBalance',
  SalesBasedPurchases: 'SalesBasedPurchases',
  SalesBasedReportCogs: 'SalesBasedReportCogs',
  SalesBasedMissingCostPerUnit: 'SalesBasedMissingCostPerUnit',
  SalesBasedClosingBalance: 'SalesBasedClosingBalance',
  UnitBasedVendorsNegativeBalance: 'UnitBasedVendorsNegativeBalance',
  UnitBasedReportCogs: 'UnitBasedReportCogs',
  UnitBasedNegativeOnHands: 'UnitBasedNegativeOnHands',
  UnitBasedClosingBalance: 'UnitBasedClosingBalance',
}

export const enumInvitationStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  EXPIRED: 'EXPIRED',
}

export const enumInvoicesYearEndTaskId = {
  CLOSE_OPEN_INVOICES: 'CLOSE_OPEN_INVOICES',
  LINK_INVOICE_PAYMENTS: 'LINK_INVOICE_PAYMENTS',
  ADD_MISSING_INVOICES: 'ADD_MISSING_INVOICES',
  CONFIRM_AR_BALANCE: 'CONFIRM_AR_BALANCE',
}

export const enumInvoicesYearEndTaskStatus = {
  INACTIVE: 'INACTIVE',
  OPEN: 'OPEN',
  REOPENED: 'REOPENED',
  PROCESSING: 'PROCESSING',
  CLOSED: 'CLOSED',
}

export const enumIrrelevantType = {
  OPEN_AFTER_SPECIFIED_DATE: 'OPEN_AFTER_SPECIFIED_DATE',
  CLOSED_DURING_THE_YEAR: 'CLOSED_DURING_THE_YEAR',
  PERSONAL_ACCOUNT: 'PERSONAL_ACCOUNT',
  BUSINESS_ACCOUNT: 'BUSINESS_ACCOUNT',
  TRANSFERRED_TO_BUSINESS_AFTER_SPECIFIED_DATE:
    'TRANSFERRED_TO_BUSINESS_AFTER_SPECIFIED_DATE',
  TRANSFERRED_FROM_BUSINESS_DURING_THE_YEAR:
    'TRANSFERRED_FROM_BUSINESS_DURING_THE_YEAR',
}

export const enumLineItemDiscountType = {
  SELLER_DISCOUNT: 'SELLER_DISCOUNT',
  PLATFORM_DISCOUNT: 'PLATFORM_DISCOUNT',
}

export const enumLineItemTimeLineActionTypeV3 = {
  PLACEMENT: 'PLACEMENT',
  FULFILLMENT: 'FULFILLMENT',
  REFUND_BEFORE_FULFILLMENT: 'REFUND_BEFORE_FULFILLMENT',
  REFUND_AFTER_FULFILLMENT: 'REFUND_AFTER_FULFILLMENT',
  OPENING_BALANCE: 'OPENING_BALANCE',
}

export const enumListAssemblyItemsSortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
}

export const enumListAssemblyItemsSortField = {
  PRODUCT_NAME: 'PRODUCT_NAME',
  RECIPE_NAME: 'RECIPE_NAME',
  DATE: 'DATE',
  AMOUNT: 'AMOUNT',
  ASSEMBLY_TYPE: 'ASSEMBLY_TYPE',
}

export const enumLoanAccountRoleEffectDirection = {
  INCREASE: 'INCREASE',
  DECREASE: 'DECREASE',
}

export const enumLoanAmountEffect = {
  DECREASE: 'DECREASE',
  INCREASE: 'INCREASE',
}

export const enumLoanAttachmentErrorType = {
  LOAN_DATE_MISMATCH: 'LOAN_DATE_MISMATCH',
  LOAN_AMOUNT_MISMATCH: 'LOAN_AMOUNT_MISMATCH',
  PARSING_FAILED: 'PARSING_FAILED',
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  OTHER: 'OTHER',
}

export const enumLoanAttachmentType = {
  AGREEMENT: 'AGREEMENT',
  AMORTIZATION_SCHEDULE: 'AMORTIZATION_SCHEDULE',
  STATEMENT: 'STATEMENT',
  REPAYMENT_SCHEDULE: 'REPAYMENT_SCHEDULE',
  AMENDMENT: 'AMENDMENT',
  RECONCILIATION: 'RECONCILIATION',
}

export const enumLoanCompoundFrequency = {
  CONTINUOUSLY: 'CONTINUOUSLY',
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY',
}

export const enumLoanDataRequestType = {
  ONE_TIME: 'ONE_TIME',
  RECURRING: 'RECURRING',
}

export const enumLoanDirection = {
  TAKEN: 'TAKEN',
  GIVEN: 'GIVEN',
  ROLLING: 'ROLLING',
}

export const enumLoanEventFilter = {
  MANUAL: 'MANUAL',
  AUTOMATED: 'AUTOMATED',
  TRANSACTION: 'TRANSACTION',
  BILL: 'BILL',
  BILL_PAYMENT: 'BILL_PAYMENT',
  BUSINESS: 'BUSINESS',
}

export const enumLoanEventRecurrence = {
  ONCE: 'ONCE',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
}

export const enumLoanIndexType = {
  CONSUMER_PRICE_INDEX: 'CONSUMER_PRICE_INDEX',
}

export const enumLoanInstantRepaymentMethod = {
  DIRECT: 'DIRECT',
  INDIRECT: 'INDIRECT',
}

export const enumLoanInterestDays = {
  DAYS_365: 'DAYS_365',
  DAYS_360: 'DAYS_360',
  ACTUAL_DAYS: 'ACTUAL_DAYS',
}

export const enumLoanInterestRateType = {
  FIXED: 'FIXED',
  VARIABLE: 'VARIABLE',
}

export const enumLoanInterestType = {
  SIMPLE: 'SIMPLE',
  COMPOUND: 'COMPOUND',
}

export const enumLoanLenderType = {
  CompanyAffiliate: 'CompanyAffiliate',
  Vendor: 'Vendor',
  Institution: 'Institution',
}

export const enumLoanOutstandingAmountAffect = {
  DECREASE: 'DECREASE',
  INCREASE: 'INCREASE',
}

export const enumLoanPropertySource = {
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL',
}

export const enumLoanRecurringDataFrequency = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY',
}

export const enumLoanRepaymentFrequency = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  QUARTER: 'QUARTER',
  YEAR: 'YEAR',
}

export const enumLoanRepaymentType = {
  AMORTIZATION: 'AMORTIZATION',
  BALLOON: 'BALLOON',
  INTEREST_ONLY: 'INTEREST_ONLY',
  FIXED_PRINCIPAL: 'FIXED_PRINCIPAL',
  ACCRUED_INTEREST_FIRST: 'ACCRUED_INTEREST_FIRST',
}

export const enumLoanSortDirection = {
  asc: 'asc',
  desc: 'desc',
}

export const enumLoanSource = {
  INTEGRATION: 'INTEGRATION',
  TRANSACTION: 'TRANSACTION',
  BACKOFFICE: 'BACKOFFICE',
  APPLICATION: 'APPLICATION',
  BILLS: 'BILLS',
  BALANCE_TRANSACTION: 'BALANCE_TRANSACTION',
}

export const enumLoanStatus = {
  PREACTIVE: 'PREACTIVE',
  ACTIVE: 'ACTIVE',
  PAID_OFF: 'PAID_OFF',
  FORGIVEN: 'FORGIVEN',
}

export const enumLoanTermDuration = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  QUARTER: 'QUARTER',
  YEAR: 'YEAR',
}

export const enumLoanTreatmentStatus = {
  OPEN: 'OPEN',
  RECURRING: 'RECURRING',
  DONE: 'DONE',
  MISSING_DATA: 'MISSING_DATA',
  DELETED: 'DELETED',
  AUTO: 'AUTO',
}

export const enumLoanType = {
  MERCHANT_CASH_ADVANCE: 'MERCHANT_CASH_ADVANCE',
  TERM_LOAN: 'TERM_LOAN',
  REVENUE_BASED_CREDIT: 'REVENUE_BASED_CREDIT',
  FACTORING: 'FACTORING',
  AP_FINANCING: 'AP_FINANCING',
  LINE_OF_CREDIT: 'LINE_OF_CREDIT',
  INSTANT_ADVANCE: 'INSTANT_ADVANCE',
  SALE_OF_FUTURE_REVENUE: 'SALE_OF_FUTURE_REVENUE',
  CAR_LOAN: 'CAR_LOAN',
  INVENTORY_FINANCING: 'INVENTORY_FINANCING',
  CONVERTIBLE: 'CONVERTIBLE',
  RELATED_PARTY_LOAN: 'RELATED_PARTY_LOAN',
  RELATED_PARTY_BALANCE: 'RELATED_PARTY_BALANCE',
  DUE_TO_FROM_OWNER: 'DUE_TO_FROM_OWNER',
  DUE_TO_FROM_CONTRACTOR: 'DUE_TO_FROM_CONTRACTOR',
  DUE_TO_FROM_EMPLOYEE: 'DUE_TO_FROM_EMPLOYEE',
  RELATED_PARTY_CONVERTIBLE: 'RELATED_PARTY_CONVERTIBLE',
}

export const enumLoanUserActionStatus = {
  ACTION_REQUIRED: 'ACTION_REQUIRED',
  PROCESSING: 'PROCESSING',
  APPROVED: 'APPROVED',
  DELETED: 'DELETED',
}

export const enumLoanUserFollowUpType = {
  WRONG_AGREEMENT: 'WRONG_AGREEMENT',
  WRONG_AMORTIZATION_SCHEDULE: 'WRONG_AMORTIZATION_SCHEDULE',
  INVITATION_NOT_RECEIVED: 'INVITATION_NOT_RECEIVED',
  INVITATION_STEP_2: 'INVITATION_STEP_2',
  STEP_2_NOT_RECEIVED: 'STEP_2_NOT_RECEIVED',
  WRONG_REPEYMENT_SCHEDULE: 'WRONG_REPEYMENT_SCHEDULE',
  WRONG_PAYMENT_SCHEDULE: 'WRONG_PAYMENT_SCHEDULE',
  BANK_NOT_CONNECTED: 'BANK_NOT_CONNECTED',
  REQUEST_FOR_STATEMENTS: 'REQUEST_FOR_STATEMENTS',
  MISSING_AMENDMENT: 'MISSING_AMENDMENT',
  NOT_THE_STATEMENT: 'NOT_THE_STATEMENT',
  NOT_THE_RECONCILIATION_REPORT: 'NOT_THE_RECONCILIATION_REPORT',
  MISSING_THE_TRANSACTION_STATEMENT: 'MISSING_THE_TRANSACTION_STATEMENT',
  WRONG_PAYMENT_HISTORY: 'WRONG_PAYMENT_HISTORY',
  MISSING_STATEMENT: 'MISSING_STATEMENT',
  RECONCILIATION_NEEDED: 'RECONCILIATION_NEEDED',
}

export const enumLoanVariableInterestBase = {
  PRIME: 'PRIME',
  SOFR: 'SOFR',
}

export const enumLoanVariableInterestUpdatePeriod = {
  MONTH: 'MONTH',
  QUARTER: 'QUARTER',
  YEAR_2: 'YEAR_2',
  YEAR_5: 'YEAR_5',
  CUSTOM: 'CUSTOM',
}

export const enumLockAction = {
  LOCK: 'LOCK',
  UNLOCK: 'UNLOCK',
}

export const enumLockConditionStatus = {
  Ok: 'Ok',
  NotOk: 'NotOk',
}

export const enumLockType = {
  lock: 'lock',
  unlock: 'unlock',
}

export const enumManageBalanceSheetSetupStatus = {
  ERROR: 'ERROR',
  RESET_SUCCESSFULLY: 'RESET_SUCCESSFULLY',
  CREATED_SUCCESSFULLY: 'CREATED_SUCCESSFULLY',
  OPEN_SUCCESSFULLY: 'OPEN_SUCCESSFULLY',
  COMPANY_NOT_FOUND: 'COMPANY_NOT_FOUND',
}

export const enumManagementMethod = {
  PURCHASE_BASED: 'PURCHASE_BASED',
  SALES_BASED: 'SALES_BASED',
  SALES_BASED_UNIT_TRACKING: 'SALES_BASED_UNIT_TRACKING',
}

export const enumManageYearEndOperations = {
  RESET: 'RESET',
  INITIALISE: 'INITIALISE',
  SETUP: 'SETUP',
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
  SET_NA: 'SET_NA',
  SET_INACTIVE: 'SET_INACTIVE',
  SET_USER_ACTIVE: 'SET_USER_ACTIVE',
  SET_USER_INACTIVE: 'SET_USER_INACTIVE',
}

export const enumManageYearEndOperationStatus = {
  ERROR: 'ERROR',
  NOT_AFFECTED: 'NOT_AFFECTED',
  SUCCESSFULL: 'SUCCESSFULL',
  NOT_FOUND: 'NOT_FOUND',
}

export const enumMarkOrderType = {
  UN_COLLECTIBLE: 'UN_COLLECTIBLE',
  OVER_COLLECTIBLE: 'OVER_COLLECTIBLE',
  VOIDED: 'VOIDED',
}

export const enumMerchantType = {
  VENDOR: 'VENDOR',
  CUSTOMER: 'CUSTOMER',
  COMPANY_AFFILIATE: 'COMPANY_AFFILIATE',
  INSTITUTION: 'INSTITUTION',
}

export const enumMergeResult = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
}

export const enumMetricRangeGroupBy = {
  year: 'year',
  month: 'month',
  week: 'week',
  day: 'day',
}

export const enumMoneyDirection = {
  IN: 'IN',
  OUT: 'OUT',
  ALL: 'ALL',
}

export const enumMovementDirection = {
  IN: 'IN',
  IN_FIRST: 'IN_FIRST',
  OUT: 'OUT',
}

export const enumMovementIndirectCostType = {
  GENERAL: 'GENERAL',
  VENDOR_FEES: 'VENDOR_FEES',
  DUTIES_AND_TAX: 'DUTIES_AND_TAX',
  CUSTOM_FEES_AND_SERVICES: 'CUSTOM_FEES_AND_SERVICES',
  INSURANCE: 'INSURANCE',
  PRODUCTION_COSTS: 'PRODUCTION_COSTS',
  DISCOUNT: 'DISCOUNT',
  SHIPPING: 'SHIPPING',
  ASSEMBLY: 'ASSEMBLY',
  SHIPPING_SURCHARGE: 'SHIPPING_SURCHARGE',
}

export const enumNaturalSign = {
  DEBIT: 'DEBIT',
  CREDIT: 'CREDIT',
}

export const enumOffersStatus = {
  READY: 'READY',
  TIER_1: 'TIER_1',
  TOO_EARLY_TO_OFFER: 'TOO_EARLY_TO_OFFER',
}

export const enumOfferTier = {
  TIER_1_V3: 'TIER_1_V3',
  TIER_2_V3: 'TIER_2_V3',
  TIER_3_V3: 'TIER_3_V3',
  TIER_4_V3: 'TIER_4_V3',
  TIER_5_V3: 'TIER_5_V3',
  TIER_6_V3: 'TIER_6_V3',
  TIER_7_V3: 'TIER_7_V3',
}

export const enumOnboardingScope = {
  INVENTORY: 'INVENTORY',
  DASHBOARD: 'DASHBOARD',
}

export const enumOnboardingStepStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
}

export const enumOrderActionType = {
  PAYMENT: 'PAYMENT',
  REFUND: 'REFUND',
  ADJUSTMENT: 'ADJUSTMENT',
}

export const enumOrderAdjustmentType = {
  UNCOLLECTIBLE: 'UNCOLLECTIBLE',
  OVERCOLLECTED: 'OVERCOLLECTED',
  HISTORICAL_PAYMENT_PRIOR_BOOKS: 'HISTORICAL_PAYMENT_PRIOR_BOOKS',
  HISTORICAL_PAYMENT_LOCKED_YEAR: 'HISTORICAL_PAYMENT_LOCKED_YEAR',
}

export const enumOrderAdjustmentTypeV3 = {
  UNCOLLECTIBLE: 'UNCOLLECTIBLE',
  OVERCOLLECTED: 'OVERCOLLECTED',
}

export const enumOrderAggregationType = {
  BALANCE_SUM: 'BALANCE_SUM',
  COUNT: 'COUNT',
  ORDER_VALUE_AVG: 'ORDER_VALUE_AVG',
  NET_SALES_SUM: 'NET_SALES_SUM',
  ORDERS_AGING: 'ORDERS_AGING',
}

export const enumOrderEntityType = {
  Order: 'Order',
  OrderItem: 'OrderItem',
  OrderTransaction: 'OrderTransaction',
  OrderItemsFulfillment: 'OrderItemsFulfillment',
  OrderTransactionsMatch: 'OrderTransactionsMatch',
}

export const enumOrderFinaloopStatus = {
  UNCOLLECTIBLE: 'UNCOLLECTIBLE',
  OVERCOLLECTED: 'OVERCOLLECTED',
  VOIDED: 'VOIDED',
  PARTIALLY_VOIDED: 'PARTIALLY_VOIDED',
  SALES_AFFECTING: 'SALES_AFFECTING',
  EXCLUDED: 'EXCLUDED',
  COGS_ONLY: 'COGS_ONLY',
  SALES_ONLY: 'SALES_ONLY',
  GIVEAWAY: 'GIVEAWAY',
}

export const enumOrderFulfillmentSource = {
  INTEGRATION: 'INTEGRATION',
  ARTIFICIAL: 'ARTIFICIAL',
  CUSTOMER: 'CUSTOMER',
}

export const enumOrderFulfillmentStatus = {
  FULFILLED: 'FULFILLED',
  PARTIALLY_FULFILLED: 'PARTIALLY_FULFILLED',
  UNFULFILLED: 'UNFULFILLED',
}

export const enumOrderFulfillmentStatusInput = {
  FULFILLED: 'FULFILLED',
  PARTIALLY_FULFILLED: 'PARTIALLY_FULFILLED',
  UNFULFILLED: 'UNFULFILLED',
  RESTOCKED: 'RESTOCKED',
}

export const enumOrderFulfillmentStatusV3 = {
  UNFULFILLED: 'UNFULFILLED',
  ATTEMPTED_DELIVERY: 'ATTEMPTED_DELIVERY',
  CANCELED: 'CANCELED',
  CONFIRMED: 'CONFIRMED',
  DELIVERED: 'DELIVERED',
  DELAYED: 'DELAYED',
  FAILURE: 'FAILURE',
  FULFILLED: 'FULFILLED',
  IN_TRANSIT: 'IN_TRANSIT',
  LABEL_PRINTED: 'LABEL_PRINTED',
  LABEL_PURCHASED: 'LABEL_PURCHASED',
  LABEL_VOIDED: 'LABEL_VOIDED',
  MARKED_AS_FULFILLED: 'MARKED_AS_FULFILLED',
  NOT_DELIVERED: 'NOT_DELIVERED',
  OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
  PICKED_UP: 'PICKED_UP',
  READY_FOR_PICKUP: 'READY_FOR_PICKUP',
  SUBMITTED: 'SUBMITTED',
}

export const enumOrderGroupExpenseType = {
  ADVERTISING: 'ADVERTISING',
  BRICK_AND_MORTAR: 'BRICK_AND_MORTAR',
  DEDUCTION: 'DEDUCTION',
  DISCOUNT: 'DISCOUNT',
  FEE: 'FEE',
  MERCHANT_FEE: 'MERCHANT_FEE',
  SELLING_FEE: 'SELLING_FEE',
  FX_COMMISSION: 'FX_COMMISSION',
  PLATFORM_ADJUSTMENT: 'PLATFORM_ADJUSTMENT',
  ORDERS_CREDIT: 'ORDERS_CREDIT',
  OTHER_ADJUSTMENT: 'OTHER_ADJUSTMENT',
}

export const enumOrderGroupsSortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
}

export const enumOrderGroupsSortType = {
  POSTED_AT: 'POSTED_AT',
}

export const enumOrderItemStatus = {
  VOIDED: 'VOIDED',
  PARTIALLY_VOIDED: 'PARTIALLY_VOIDED',
  FULFILLED: 'FULFILLED',
  UNFULFILLED: 'UNFULFILLED',
  PARTIALLY_FULFILLED: 'PARTIALLY_FULFILLED',
  RESTOCKED: 'RESTOCKED',
  PARTIALLY_RESTOCKED: 'PARTIALLY_RESTOCKED',
  CANCELLED: 'CANCELLED',
  GIVEAWAY: 'GIVEAWAY',
  DROPSHIPPED: 'DROPSHIPPED',
  PARTIALLY_DROPSHIPPED: 'PARTIALLY_DROPSHIPPED',
}

export const enumOrderItemType = {
  SHIPPING: 'SHIPPING',
  PRODUCT: 'PRODUCT',
  ADDITIONAL_FEE: 'ADDITIONAL_FEE',
  GIFT_CARD: 'GIFT_CARD',
  TIP: 'TIP',
  FX_ADJUSTMENT: 'FX_ADJUSTMENT',
  DUTY: 'DUTY',
  RESTOCKING_FEE: 'RESTOCKING_FEE',
  RETURN_SHIPPING_FEE: 'RETURN_SHIPPING_FEE',
}

export const enumOrderLineItemDiscountType = {
  PLATFORM_DISCOUNT: 'PLATFORM_DISCOUNT',
  SELLER_DISCOUNT: 'SELLER_DISCOUNT',
  COFUNDED_DISCOUNT: 'COFUNDED_DISCOUNT',
}

export const enumOrderLineItemTaxType = {
  DUTIES_AND_OTHER_TAXES: 'DUTIES_AND_OTHER_TAXES',
  GST: 'GST',
  SALES_TAX: 'SALES_TAX',
  VAT: 'VAT',
}

export const enumOrderLineItemType = {
  PRODUCT: 'PRODUCT',
  GIFT_CARD: 'GIFT_CARD',
}

export const enumOrderLineItemTypeV3 = {
  PRODUCT: 'PRODUCT',
  TAX: 'TAX',
  FEE: 'FEE',
  TIP: 'TIP',
  SHIPPING: 'SHIPPING',
  DISCOUNT: 'DISCOUNT',
}

export const enumOrderPaymentStatus = {
  PAID: 'PAID',
  UNPAID: 'UNPAID',
  PARTIALLY_PAID: 'PARTIALLY_PAID',
  REFUNDED: 'REFUNDED',
  PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
}

export const enumOrderReconciliationRowType = {
  ENTITY: 'ENTITY',
  ACCOUNT: 'ACCOUNT',
}

export const enumOrderReturnLineItemTypeV3 = {
  RETURN: 'RETURN',
  CANCEL: 'CANCEL',
}

export const enumOrdersAgingPreset = {
  ZERO_TO_THIRTY: 'ZERO_TO_THIRTY',
  THIRTY_ONE_TO_SIXTY: 'THIRTY_ONE_TO_SIXTY',
  SIXTY_ONE_TO_NINETY: 'SIXTY_ONE_TO_NINETY',
  NINETY_ONE_PLUS: 'NINETY_ONE_PLUS',
}

export const enumOrderSettlementStatusInput = {
  SETTLED: 'SETTLED',
  PARTIALLY_SETTLED: 'PARTIALLY_SETTLED',
  UNSETTLED: 'UNSETTLED',
}

export const enumOrderSourceTypeV3 = {
  MARKETPLACE: 'MARKETPLACE',
  STORE: 'STORE',
}

export const enumOrdersSortType = {
  PLACED_DATE: 'PLACED_DATE',
  NET_SALES: 'NET_SALES',
  TOTAL: 'TOTAL',
  UNPAID_BALANCE: 'UNPAID_BALANCE',
  BALANCE: 'BALANCE',
}

export const enumOrderStatus = {
  VOIDED: 'VOIDED',
  COGS_ONLY: 'COGS_ONLY',
  SALES_ONLY: 'SALES_ONLY',
  GIVEAWAY: 'GIVEAWAY',
  EXCLUDED: 'EXCLUDED',
  PAID: 'PAID',
  UNPAID: 'UNPAID',
  PARTIALLY_PAID: 'PARTIALLY_PAID',
  REFUNDED: 'REFUNDED',
  PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
  DROPSHIPPED: 'DROPSHIPPED',
  FULFILLED: 'FULFILLED',
  RESTOCKED: 'RESTOCKED',
  PARTIALLY_DROPSHIPPED: 'PARTIALLY_DROPSHIPPED',
  PARTIALLY_FULFILLED: 'PARTIALLY_FULFILLED',
  PARTIALLY_RESTOCKED: 'PARTIALLY_RESTOCKED',
  PARTIALLY_VOIDED: 'PARTIALLY_VOIDED',
  UNFULFILLED: 'UNFULFILLED',
  CANCELLED: 'CANCELLED',
  UNCOLLECTIBLE: 'UNCOLLECTIBLE',
  PARTIALLY_UNCOLLECTIBLE: 'PARTIALLY_UNCOLLECTIBLE',
  PARTIALLY_OVER_COLLECTED: 'PARTIALLY_OVER_COLLECTED',
  HISTORICALLY_PAID: 'HISTORICALLY_PAID',
  PARTIALLY_HISTORICALLY_PAID: 'PARTIALLY_HISTORICALLY_PAID',
  OVER_COLLECTED: 'OVER_COLLECTED',
  MATCHED_TRANSACTION: 'MATCHED_TRANSACTION',
  UNMATCHED_TRANSACTION: 'UNMATCHED_TRANSACTION',
  LINKED_TRANSACTIONS: 'LINKED_TRANSACTIONS',
}

export const enumOrderStatusInput = {
  GIVEAWAY: 'GIVEAWAY',
  VOIDED: 'VOIDED',
}

export const enumOrderStatusV3 = {
  VOIDED: 'VOIDED',
  COGS_ONLY: 'COGS_ONLY',
  SALES_ONLY: 'SALES_ONLY',
  GIVEAWAY: 'GIVEAWAY',
  EXCLUDED: 'EXCLUDED',
  PAID: 'PAID',
  UNPAID: 'UNPAID',
  PARTIALLY_PAID: 'PARTIALLY_PAID',
  REFUNDED: 'REFUNDED',
  PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
  FULFILLED: 'FULFILLED',
  PARTIALLY_FULFILLED: 'PARTIALLY_FULFILLED',
  UNFULFILLED: 'UNFULFILLED',
  RESTOCKED: 'RESTOCKED',
  PARTIALLY_RESTOCKED: 'PARTIALLY_RESTOCKED',
  OVER_COLLECTED: 'OVER_COLLECTED',
  PARTIALLY_OVER_COLLECTED: 'PARTIALLY_OVER_COLLECTED',
  UNCOLLECTIBLE: 'UNCOLLECTIBLE',
  PARTIALLY_UNCOLLECTIBLE: 'PARTIALLY_UNCOLLECTIBLE',
  COGS_AND_SALES: 'COGS_AND_SALES',
  DROPSHIPPED: 'DROPSHIPPED',
  PARTIALLY_DROPSHIPPED: 'PARTIALLY_DROPSHIPPED',
  UNSETTLED: 'UNSETTLED',
  PARTIALLY_SETTLED: 'PARTIALLY_SETTLED',
  SETTLED: 'SETTLED',
}

export const enumOrderTransactionType = {
  PAYMENT: 'PAYMENT',
  REFUND: 'REFUND',
}

export const enumOrderVoidedByType = {
  FINALOOP: 'FINALOOP',
  INTEGRATION: 'INTEGRATION',
}

export const enumOverviewConnectionStatus = {
  CLOSED: 'CLOSED',
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',
  IMPORT_STOPPED: 'IMPORT_STOPPED',
  MANUAL: 'MANUAL',
}

export const enumPaidStatus = {
  PAID: 'PAID',
  PARTIALLY_PAID: 'PARTIALLY_PAID',
  UNPAID: 'UNPAID',
}

export const enumPairedEntityType = {
  BANK_AFFECTING_INTEGRATION_EVENT: 'BANK_AFFECTING_INTEGRATION_EVENT',
  BANK_TRANSACTION: 'BANK_TRANSACTION',
  BILL: 'BILL',
  INVOICE: 'INVOICE',
  ORDER_GROUP: 'ORDER_GROUP',
  COMPANY_AFFILIATE_BALANCE: 'COMPANY_AFFILIATE_BALANCE',
  PAYMENT_CHECK: 'PAYMENT_CHECK',
  PAYROLL: 'PAYROLL',
  PAYMENT_GROUP: 'PAYMENT_GROUP',
}

export const enumPairingType = {
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
  MATCH: 'MATCH',
  REFUND: 'REFUND',
  FAILED_TRANSFER: 'FAILED_TRANSFER',
}

export const enumParentLineItemType = {
  PRODUCT: 'PRODUCT',
  TAX: 'TAX',
  SHIPPING: 'SHIPPING',
  DISCOUNT: 'DISCOUNT',
  FEE: 'FEE',
  TIP: 'TIP',
}

export const enumPaymentFeeBasis = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED: 'FIXED',
}

export const enumPaymentFeeType = {
  PROCESSING: 'PROCESSING',
  DISPUTE: 'DISPUTE',
}

export const enumPaymentGateway = {
  AFTERPAY: 'AFTERPAY',
  AMAZON_PAY: 'AMAZON_PAY',
  PAYPAL: 'PAYPAL',
  SHOP_PAY: 'SHOP_PAY',
  STRIPE: 'STRIPE',
  GIFT_CARD: 'GIFT_CARD',
  EXCHANGE_CREDIT: 'EXCHANGE_CREDIT',
  STORE_CREDIT: 'STORE_CREDIT',
  MANUAL: 'MANUAL',
  UNKNOWN: 'UNKNOWN',
  NO_GATEWAY: 'NO_GATEWAY',
  AFFIRM: 'AFFIRM',
  ALMA: 'ALMA',
  AUTHORIZE_NET: 'AUTHORIZE_NET',
  BLACKCART: 'BLACKCART',
  BRAINTREE: 'BRAINTREE',
  CLEARCO: 'CLEARCO',
  CLEARPAY: 'CLEARPAY',
  FAIRE: 'FAIRE',
  PARKER: 'PARKER',
  KLARNA: 'KLARNA',
  KLICKLY: 'KLICKLY',
  SETTLE: 'SETTLE',
  SEZZLE: 'SEZZLE',
  QUICKBOOKS_PAYMENTS: 'QUICKBOOKS_PAYMENTS',
  SQUARE: 'SQUARE',
  WOOCOMMERCE: 'WOOCOMMERCE',
  FACEBOOK: 'FACEBOOK',
  ZIP_CO: 'ZIP_CO',
  SPLITIT: 'SPLITIT',
  BREAD_PAY: 'BREAD_PAY',
  GLOBAL_E: 'GLOBAL_E',
  SNACK_MAGIC: 'SNACK_MAGIC',
  POSTAL: 'POSTAL',
  CORPORATE_GIFT: 'CORPORATE_GIFT',
  CAROO: 'CAROO',
}

export const enumPaymentGatewayType = {
  AFFIRM: 'AFFIRM',
  AMAZON_PAY: 'AMAZON_PAY',
  BRAINTREE: 'BRAINTREE',
  FAIRE: 'FAIRE',
  KLARNA: 'KLARNA',
  SEZZLE: 'SEZZLE',
  TRUE_MED: 'TRUE_MED',
}

export const enumPaymentGroupExpenseType = {
  ADVERTISING: 'ADVERTISING',
  BRICK_AND_MORTAR: 'BRICK_AND_MORTAR',
  DEDUCTION: 'DEDUCTION',
  DISCOUNT: 'DISCOUNT',
  FEE: 'FEE',
  MERCHANT_FEE: 'MERCHANT_FEE',
  SELLING_FEE: 'SELLING_FEE',
  FX_COMMISSION: 'FX_COMMISSION',
  PLATFORM_ADJUSTMENT: 'PLATFORM_ADJUSTMENT',
  ORDERS_CREDIT: 'ORDERS_CREDIT',
}

export const enumPaymentGroupsSortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
}

export const enumPaymentGroupsSortType = {
  POSTED_AT: 'POSTED_AT',
}

export const enumPaymentGroupType = {
  INVOICE: 'INVOICE',
  ORDER: 'ORDER',
}

export const enumPaymentLinkStatus = {
  LIVE: 'LIVE',
  PROCESSING: 'PROCESSING',
  PAID: 'PAID',
  FAILED: 'FAILED',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED',
}

export const enumPaymentMethodType = {
  ACH: 'ACH',
  CHECK: 'CHECK',
  CUSTOM: 'CUSTOM',
  INVOICE_PAY: 'INVOICE_PAY',
}

export const enumPaymentRecurrence = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
}

export const enumPayrollCategory = {
  DEFAULT: 'DEFAULT',
  INVENTORY: 'INVENTORY',
  RESEARCH_AND_DEVELOPMENT: 'RESEARCH_AND_DEVELOPMENT',
  SHIPPING_AND_FULFILLMENT: 'SHIPPING_AND_FULFILLMENT',
  MARKETING: 'MARKETING',
  GENERAL_AND_ADMINISTRATIVE: 'GENERAL_AND_ADMINISTRATIVE',
}

export const enumPayrollCategoryMappingMode = {
  DEPARTMENT: 'DEPARTMENT',
  PERSONNEL: 'PERSONNEL',
}

export const enumPayrollEmploymentType = {
  EMPLOYEE: 'EMPLOYEE',
  OFFICER: 'OFFICER',
  PARTNER: 'PARTNER',
}

export const enumPayrollIntegrationTransferType = {
  NET_PAY: 'NET_PAY',
  TAX: 'TAX',
  REIMBURSEMENT: 'REIMBURSEMENT',
  GARNISHMENT: 'GARNISHMENT',
  RETIREMENT: 'RETIREMENT',
  GENERAL: 'GENERAL',
}

export const enumPayrollMappableType = {
  DEPARTMENT: 'DEPARTMENT',
  EMPLOYEE: 'EMPLOYEE',
  CONTRACTOR: 'CONTRACTOR',
}

export const enumPendingProductAdjustmentsDataType = {
  MISSING: 'MISSING',
  PENDING: 'PENDING',
}

export const enumPlatform = {
  FACEBOOK_ADS: 'FACEBOOK_ADS',
  GOOGLE_ADS: 'GOOGLE_ADS',
}

export const enumProductAppliedCostSource = {
  USER: 'USER',
  SHOPIFY: 'SHOPIFY',
}

export const enumProductAppliedCostType = {
  GENERAL: 'GENERAL',
  DROPSHIPPING: 'DROPSHIPPING',
}

export const enumProductAttributesTypes = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  MERGED: 'MERGED',
  NOT_MERGED: 'NOT_MERGED',
  HAS_RECIPE: 'HAS_RECIPE',
  NO_RECIPE: 'NO_RECIPE',
  COMPONENT_OF: 'COMPONENT_OF',
  NOT_COMPONENT_OF: 'NOT_COMPONENT_OF',
  VISIBLE: 'VISIBLE',
  NOT_VISIBLE: 'NOT_VISIBLE',
  FRACTIONAL: 'FRACTIONAL',
  NOT_FRACTIONAL: 'NOT_FRACTIONAL',
  DROPSHIPPING: 'DROPSHIPPING',
  NOT_DROPSHIPPING: 'NOT_DROPSHIPPING',
}

export const enumProductBulkAdjustmentStatusState = {
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
  FAILED: 'FAILED',
}

export const enumProductBulkAdjustmentStatusType = {
  SALES: 'SALES',
  DEAD_INVENTORY: 'DEAD_INVENTORY',
  GIVEAWAY: 'GIVEAWAY',
  GIVEAWAY_DROPSHIPPING: 'GIVEAWAY_DROPSHIPPING',
  DONATIONS: 'DONATIONS',
}

export const enumProductBulkEditCsvAttachmentType = {
  PHYSICAL_COUNT_UNIT_TRACKING: 'PHYSICAL_COUNT_UNIT_TRACKING',
  PHYSICAL_COUNT_NO_UNIT_TRACKING: 'PHYSICAL_COUNT_NO_UNIT_TRACKING',
  WAREHOUSE_OPENING_BALANCE: 'WAREHOUSE_OPENING_BALANCE',
  SALES_ADJUSTMENTS: 'SALES_ADJUSTMENTS',
  DEAD_INVENTORY_ADJUSTMENTS: 'DEAD_INVENTORY_ADJUSTMENTS',
  DONATIONS_ADJUSTMENTS: 'DONATIONS_ADJUSTMENTS',
  GIVEN_AWAY_ADJUSTMENTS: 'GIVEN_AWAY_ADJUSTMENTS',
  GIVEN_AWAY_DROPSHIPPING_ADJUSTMENTS: 'GIVEN_AWAY_DROPSHIPPING_ADJUSTMENTS',
}

export const enumProductBulkEditCsvErrorItemType = {
  INVALID_HEADERS: 'INVALID_HEADERS',
  MISSING_PRODUCT: 'MISSING_PRODUCT',
  MISSING_QUANTITY: 'MISSING_QUANTITY',
  ROW_DUPLICATE: 'ROW_DUPLICATE',
  PRODUCT_AMBIGUOUS: 'PRODUCT_AMBIGUOUS',
  PRODUCT_NOT_FOUND: 'PRODUCT_NOT_FOUND',
  MISSING_WAREHOUSE: 'MISSING_WAREHOUSE',
  MISSING_COST: 'MISSING_COST',
  WAREHOUSE_AMBIGUOUS: 'WAREHOUSE_AMBIGUOUS',
  WAREHOUSE_NOT_FOUND: 'WAREHOUSE_NOT_FOUND',
  INVALID_DATA: 'INVALID_DATA',
  MISSING_DATE: 'MISSING_DATE',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  MISSING_SOLD_AND_RESTOCKED: 'MISSING_SOLD_AND_RESTOCKED',
  DATE_OUT_OF_METHOD_RANGE: 'DATE_OUT_OF_METHOD_RANGE',
}

export const enumProductMergeLogSortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
}

export const enumProductMergeLogSortField = {
  DATE: 'DATE',
  DISPLAY_NAME: 'DISPLAY_NAME',
  SKU: 'SKU',
  SOURCE: 'SOURCE',
  TYPE: 'TYPE',
}

export const enumProductMergeLogTrigger = {
  MANUAL: 'MANUAL',
  MANUAL_RECOMMENDATION: 'MANUAL_RECOMMENDATION',
  AUTOMATIC: 'AUTOMATIC',
  MULTI: 'MULTI',
}

export const enumProductMergeLogTriggerType = {
  MANUAL: 'MANUAL',
  AUTOMATIC_SUGGESTION: 'AUTOMATIC_SUGGESTION',
  MANUAL_SUGGESTION: 'MANUAL_SUGGESTION',
  MULTI: 'MULTI',
}

export const enumProductMergeRecommendationsGroupType = {
  PERFECT: 'PERFECT',
  FLEXIBLE: 'FLEXIBLE',
  SMART: 'SMART',
}

export const enumProductQuantityFilter = {
  MISSING_DATA: 'MISSING_DATA',
  PENDING_CHANGES: 'PENDING_CHANGES',
}

export const enumProductSource = {
  AMAZON: 'AMAZON',
  WALMART: 'WALMART',
  USER_MANUAL: 'USER_MANUAL',
  SHOPIFY: 'SHOPIFY',
}

export const enumProductSourceV3 = {
  TRACKSTAR_FBA: 'TRACKSTAR_FBA',
  AMAZON: 'AMAZON',
  WALMART: 'WALMART',
  USER_MANUAL: 'USER_MANUAL',
  SHOPIFY: 'SHOPIFY',
  TIK_TOK: 'TIK_TOK',
}

export const enumProductsSortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
}

export const enumPurchaseOrdersSortField = {
  productionStartDate: 'productionStartDate',
  landedCostTotal: 'landedCostTotal',
  createdAt: 'createdAt',
  paidStatus: 'paidStatus',
  poName: 'poName',
}

export const enumPurchaseOrderStatus = {
  DRAFT: 'DRAFT',
  PLACED: 'PLACED',
  IN_PROCESS: 'IN_PROCESS',
  PARTIALLY_SHIPPED: 'PARTIALLY_SHIPPED',
  SHIPPED: 'SHIPPED',
  PARTIALLY_RECEIVED: 'PARTIALLY_RECEIVED',
  RECEIVED: 'RECEIVED',
}

export const enumRecipeAllocatedCostType = {
  PRODUCTION_COSTS: 'PRODUCTION_COSTS',
  PRODUCTION_LABOR_COSTS: 'PRODUCTION_LABOR_COSTS',
  OTHER: 'OTHER',
}

export const enumRecipeManagementMethod = {
  UNITS_TRACKING: 'UNITS_TRACKING',
  NO_UNITS_TRACKING: 'NO_UNITS_TRACKING',
}

export const enumRecommendationSource = {
  BANK_TRANSACTION: 'BANK_TRANSACTION',
  LOCAL_MERCHANT: 'LOCAL_MERCHANT',
  GLOBAL_MERCHANT: 'GLOBAL_MERCHANT',
}

export const enumRecommendedBy = {
  FINALOOP_SUGGESTIONS: 'FINALOOP_SUGGESTIONS',
  ASK_AI: 'ASK_AI',
}

export const enumReconciliationStatus = {
  RECONCILED: 'RECONCILED',
  RECONCILIATION_NEEDED: 'RECONCILIATION_NEEDED',
  PROCESSING: 'PROCESSING',
  UNKNOWN: 'UNKNOWN',
}

export const enumReportSyncStatus = {
  PROCESSING: 'PROCESSING',
  SYNCED: 'SYNCED',
  FAILED: 'FAILED',
}

export const enumReportType = {
  PROFIT_AND_LOSS: 'PROFIT_AND_LOSS',
  BALANCE_SHEET: 'BALANCE_SHEET',
  CASH_FLOW: 'CASH_FLOW',
}

export const enumRestockStatus = {
  PARTIALLY_RESTOCKED: 'PARTIALLY_RESTOCKED',
  RESTOCKED: 'RESTOCKED',
}

export const enumRole = {
  ADMIN: 'ADMIN',
  EMPLOYEE: 'EMPLOYEE',
  USER: 'USER',
  GUEST: 'GUEST',
}

export const enumRootConditionOperator = {
  OR: 'OR',
  AND: 'AND',
}

export const enumSaleActor = {
  INTEGRATION: 'INTEGRATION',
  CUSTOMER: 'CUSTOMER',
}

export const enumSaleLineItemType = {
  PRODUCT: 'PRODUCT',
  TAX: 'TAX',
  SHIPPING: 'SHIPPING',
  SELLER_DISCOUNT: 'SELLER_DISCOUNT',
  PLATFORM_DISCOUNT: 'PLATFORM_DISCOUNT',
  FEE: 'FEE',
  SERVICE: 'SERVICE',
  TIP: 'TIP',
}

export const enumSaleSource = {
  FINALOOP_INVOICES: 'FINALOOP_INVOICES',
  STRIPE: 'STRIPE',
  PAYPAL: 'PAYPAL',
  QUICKBOOKS: 'QUICKBOOKS',
  QUICKBOOKS_INVOICES: 'QUICKBOOKS_INVOICES',
  NU_ORDER_INVOICES: 'NU_ORDER_INVOICES',
  SPS_COMMERCE: 'SPS_COMMERCE',
  FINALOOP_ORDERS: 'FINALOOP_ORDERS',
  TIK_TOK: 'TIK_TOK',
}

export const enumSaleStatus = {
  DRAFT: 'DRAFT',
  FOR_REVIEW: 'FOR_REVIEW',
  VOIDED: 'VOIDED',
  COGS_ONLY: 'COGS_ONLY',
  GIVEAWAY: 'GIVEAWAY',
  OPEN: 'OPEN',
  PAST_DUE: 'PAST_DUE',
  PAID: 'PAID',
  REFUNDED: 'REFUNDED',
  CLOSED: 'CLOSED',
  UNCOLLECTIBLE: 'UNCOLLECTIBLE',
  OVER_COLLECTED: 'OVER_COLLECTED',
  ADJUSTED: 'ADJUSTED',
  PARTIALLY_UNCOLLECTIBLE: 'PARTIALLY_UNCOLLECTIBLE',
  PARTIALLY_ADJUSTED: 'PARTIALLY_ADJUSTED',
  PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
  PARTIALLY_PAID: 'PARTIALLY_PAID',
}

export const enumSaleTaxType = {
  SALES_TAX: 'SALES_TAX',
  VAT: 'VAT',
  GST: 'GST',
}

export const enumSaleType = {
  ORDER: 'ORDER',
  INVOICE: 'INVOICE',
}

export const enumSellingFeeType = {
  SELLING_FEE: 'SELLING_FEE',
  AFFILIATE_COMMISSION: 'AFFILIATE_COMMISSION',
}

export const enumSetProductAdjustmentOperation = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  ADD_ON_TOP: 'ADD_ON_TOP',
  UPDATE_GOING_FORWARD: 'UPDATE_GOING_FORWARD',
  REPLACE: 'REPLACE',
}

export const enumShareType = {
  COMMON_STOCK: 'COMMON_STOCK',
  PREFERRED: 'PREFERRED',
}

export const enumShippingCostType = {
  SHIPPING_OUT_TO_CUSTOMERS: 'SHIPPING_OUT_TO_CUSTOMERS',
  SHIPPING_BACK_FROM_CUSTOMERS: 'SHIPPING_BACK_FROM_CUSTOMERS',
}

export const enumShopifyValidationItemType = {
  RESTOCKED: 'RESTOCKED',
  VOIDED: 'VOIDED',
  IN_BOOKS: 'IN_BOOKS',
  ZERO_NET: 'ZERO_NET',
  EXCLUDED: 'EXCLUDED',
  ZERO_PRICE: 'ZERO_PRICE',
}

export const enumSimpleMoneyDirection = {
  IN: 'IN',
  OUT: 'OUT',
}

export const enumSortByMerchants = {
  TRANSACTIONS_AMOUNT_DESC: 'TRANSACTIONS_AMOUNT_DESC',
}

export const enumSortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
}

export const enumSourceTypes = {
  INVOICE: 'INVOICE',
  SHOPIFY: 'SHOPIFY',
  TIK_TOK: 'TIK_TOK',
}

export const enumSpreadBasisType = {
  DAILY: 'DAILY',
  MONTHLY: 'MONTHLY',
}

export const enumSpreadType = {
  SPECIFIC_DATE: 'SPECIFIC_DATE',
  SPREAD_OVER_TIME: 'SPREAD_OVER_TIME',
  CUSTOM_SPREAD: 'CUSTOM_SPREAD',
  FIXED_ASSETS_DEFAULT: 'FIXED_ASSETS_DEFAULT',
  FIXED_ASSETS_CUSTOM: 'FIXED_ASSETS_CUSTOM',
}

export const enumStoreOrderTransactionMatchType = {
  PAYMENT: 'PAYMENT',
  BANK_TRANSACTION: 'BANK_TRANSACTION',
}

export const enumSyncCompanyEventName = {
  INSERT: 'INSERT',
  MODIFY: 'MODIFY',
  REMOVE: 'REMOVE',
}

export const enumTax1099AffiliatedEntityDisqualifyReason = {
  CORPORATION: 'CORPORATION',
  NON_US_TAXPAYER: 'NON_US_TAXPAYER',
  NOT_A_SERVICE_PROVIDER: 'NOT_A_SERVICE_PROVIDER',
  FREIGHT_OR_STORAGE_SERVICE_PROVIDER: 'FREIGHT_OR_STORAGE_SERVICE_PROVIDER',
  BANK: 'BANK',
  NOT_A_DIVIDEND: 'NOT_A_DIVIDEND',
}

export const enumTax1099AffiliatedEntityType = {
  NEC: 'NEC',
  MISC: 'MISC',
  DIV: 'DIV',
  INT: 'INT',
}

export const enumTimeBreakdownUnit = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  QUARTER: 'QUARTER',
  YEAR: 'YEAR',
}

export const enumTransactionKind = {
  PAYMENT: 'PAYMENT',
  REFUND: 'REFUND',
}

export const enumTransactionPaymentGatewayType = {
  AAFES: 'AAFES',
  ADYEN: 'ADYEN',
  AFFIRM: 'AFFIRM',
  AFTERPAY: 'AFTERPAY',
  AIRWALLEX: 'AIRWALLEX',
  ALMA: 'ALMA',
  AMAZON: 'AMAZON',
  AMAZON_PAY: 'AMAZON_PAY',
  AUTHORIZE_NET: 'AUTHORIZE_NET',
  BANKFUL: 'BANKFUL',
  BLACKCART: 'BLACKCART',
  BLOOM: 'BLOOM',
  BN: 'BN',
  BRAINTREE: 'BRAINTREE',
  BREAD_PAY: 'BREAD_PAY',
  CAROO: 'CAROO',
  CARRO: 'CARRO',
  CATCH: 'CATCH',
  CHANNEL_ADVISOR: 'CHANNEL_ADVISOR',
  CHECKOUT_COM: 'CHECKOUT_COM',
  CLEARCO: 'CLEARCO',
  CLEARPAY: 'CLEARPAY',
  COINBASE: 'COINBASE',
  COMMENT_SOLD: 'COMMENT_SOLD',
  CORPORATE_GIFT: 'CORPORATE_GIFT',
  CVS: 'CVS',
  EBAY: 'EBAY',
  ETSY: 'ETSY',
  EXCHANGE_CREDIT: 'EXCHANGE_CREDIT',
  FACEBOOK: 'FACEBOOK',
  FAIRE: 'FAIRE',
  FOUR_BNPL: 'FOUR_BNPL',
  GIFT_CARD: 'GIFT_CARD',
  GLOBAL_E: 'GLOBAL_E',
  GLOPAL: 'GLOPAL',
  GUSTO: 'GUSTO',
  KLARNA: 'KLARNA',
  KLICKLY: 'KLICKLY',
  KROGER: 'KROGER',
  LEAP_RETAIL: 'LEAP_RETAIL',
  MANUAL: 'MANUAL',
  MIRAKL: 'MIRAKL',
  NMI: 'NMI',
  NO_GATEWAY: 'NO_GATEWAY',
  OPEN_NODE: 'OPEN_NODE',
  OPEN_PATH: 'OPEN_PATH',
  PARKER: 'PARKER',
  PARTIALLY: 'PARTIALLY',
  PAYONEER: 'PAYONEER',
  PAYPAL: 'PAYPAL',
  POSTAL: 'POSTAL',
  QUICKBOOKS_PAYMENTS: 'QUICKBOOKS_PAYMENTS',
  QVC: 'QVC',
  REACH: 'REACH',
  RECHARGE: 'RECHARGE',
  RETURNLY: 'RETURNLY',
  REVOLUT: 'REVOLUT',
  SETTLE: 'SETTLE',
  SEZZLE: 'SEZZLE',
  SHOP_PAY: 'SHOP_PAY',
  SNACK_MAGIC: 'SNACK_MAGIC',
  SPLITIT: 'SPLITIT',
  SQUARE: 'SQUARE',
  STORE_CREDIT: 'STORE_CREDIT',
  STRIPE: 'STRIPE',
  TARGET: 'TARGET',
  TIK_TOK: 'TIK_TOK',
  TRUE_MED: 'TRUE_MED',
  TWINT: 'TWINT',
  UNKNOWN: 'UNKNOWN',
  WALGREENS: 'WALGREENS',
  WALMART: 'WALMART',
  WALMART_VIA_SHOPIFY: 'WALMART_VIA_SHOPIFY',
  WISE: 'WISE',
  WOOCOMMERCE: 'WOOCOMMERCE',
  ZIP: 'ZIP',
}

export const enumTransactionPaymentType = {
  Internal: 'Internal',
  External: 'External',
}

export const enumTransactionType = {
  PAYMENT: 'PAYMENT',
  REFUND: 'REFUND',
}

export const enumUnidentifiedBankTransactionsGroupType = {
  TRANSFER: 'TRANSFER',
  BANK_TRANSFER: 'BANK_TRANSFER',
  CREDIT_CARD_PAYMENT: 'CREDIT_CARD_PAYMENT',
}

export const enumUnidentifiedTransfersGroupAction = {
  ASK_THE_USER_FLOW: 'ASK_THE_USER_FLOW',
  CONNECT_ACCOUNT: 'CONNECT_ACCOUNT',
  UPLOAD_CSV: 'UPLOAD_CSV',
  UPLOAD_STATEMENT: 'UPLOAD_STATEMENT',
  ROLE_GRANT: 'ROLE_GRANT',
}

export const enumUnitType = {
  CURRENCY: 'CURRENCY',
  PERCENTAGE: 'PERCENTAGE',
  NUMBER: 'NUMBER',
}

export const enumUnpaidAmountsViaProviderType = {
  TAXES: 'TAXES',
  HEALTH_EMPLOYEE: 'HEALTH_EMPLOYEE',
  TRANSPORTATION_EMPLOYEE: 'TRANSPORTATION_EMPLOYEE',
  OTHER_BENEFITS_EMPLOYEE: 'OTHER_BENEFITS_EMPLOYEE',
  OTHER_GARNISHMENTS: 'OTHER_GARNISHMENTS',
  OTHER_DEDUCTIONS: 'OTHER_DEDUCTIONS',
  SAVINGS_AND_RETIREMENT_OTHER_EMPLOYEE:
    'SAVINGS_AND_RETIREMENT_OTHER_EMPLOYEE',
  SAVINGS_AND_RETIREMENT_401K_EMPLOYEE: 'SAVINGS_AND_RETIREMENT_401K_EMPLOYEE',
  VACATION_PAY: 'VACATION_PAY',
  CHILD_SUPPORT: 'CHILD_SUPPORT',
}

export const enumUpdateCheckDetails = {
  RECORD_NOT_FOUND: 'RECORD_NOT_FOUND',
  INVALID_STATE_CHANGE: 'INVALID_STATE_CHANGE',
  SAME_STATE: 'SAME_STATE',
  YEAR_END_STATE_BLOCKED_FOR_CHANGES: 'YEAR_END_STATE_BLOCKED_FOR_CHANGES',
}

export const enumUpdateCheckTypes = {
  VALID: 'VALID',
  INVALID: 'INVALID',
  NOT_AFFECTED: 'NOT_AFFECTED',
  NOT_FOUND: 'NOT_FOUND',
}

export const enumUploadableIntegrationType = {
  FINALOOP_INVOICES: 'FINALOOP_INVOICES',
  QUICKBOOKS_INVOICES: 'QUICKBOOKS_INVOICES',
  NU_ORDER_INVOICES: 'NU_ORDER_INVOICES',
  SPS_COMMERCE: 'SPS_COMMERCE',
}

export const enumValidationCycleStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
}

export const enumValidationTemplateEndTime = {
  NOW: 'NOW',
  PREVIOUS_YEAR: 'PREVIOUS_YEAR',
  LOCKED_DATE: 'LOCKED_DATE',
}

export const enumValueType = {
  BENCHMARK: 'BENCHMARK',
  CURRENT: 'CURRENT',
  MARGIN: 'MARGIN',
  PREVIOUS: 'PREVIOUS',
  MAIN: 'MAIN',
}

export const enumVendorSource = {
  NTROPY: 'NTROPY',
  FINALOOP: 'FINALOOP',
  FINALOOP_BILLS: 'FINALOOP_BILLS',
  FINALOOP_TRANSACTIONS: 'FINALOOP_TRANSACTIONS',
  FINALOOP_TRANSACTIONS_MACHINE: 'FINALOOP_TRANSACTIONS_MACHINE',
  FINALOOP_MACHINE: 'FINALOOP_MACHINE',
  QUICKBOOKS: 'QUICKBOOKS',
  BILL_COM: 'BILL_COM',
  SETTLE: 'SETTLE',
  CUSTOMER: 'CUSTOMER',
}

export const enumVendorSubType = {
  AUTOMATED_PAYMENT_PROCESSOR: 'AUTOMATED_PAYMENT_PROCESSOR',
  AUTOMATED_MARKETPLACE: 'AUTOMATED_MARKETPLACE',
  NON_AUTOMATED_MARKETPLACE: 'NON_AUTOMATED_MARKETPLACE',
  NON_AUTOMATED_BRANDED_STORE: 'NON_AUTOMATED_BRANDED_STORE',
  NON_AUTOMATED_PAYMENT_PROCESSOR: 'NON_AUTOMATED_PAYMENT_PROCESSOR',
  NON_AUTOMATED_PAYMENT_GATEWAY: 'NON_AUTOMATED_PAYMENT_GATEWAY',
  NON_AUTOMATED_PAYMENT_PROCESSOR_AUTHORIZE_NET:
    'NON_AUTOMATED_PAYMENT_PROCESSOR_AUTHORIZE_NET',
  SHIPPING_CARRIER: 'SHIPPING_CARRIER',
  INVENTORY: 'INVENTORY',
}

export const enumVendorType = {
  LOCAL: 'LOCAL',
  GLOBAL: 'GLOBAL',
}

export const enumViewTypes = {
  DEFAULT: 'DEFAULT',
  BARS: 'BARS',
}

export const enumVoidStatus = {
  VOIDED: 'VOIDED',
}

export const enumWarehouseCreateErrorTypeEnum = {
  DUPLICATE: 'DUPLICATE',
}

export const enumWarehouseFilterType = {
  ORIGIN: 'ORIGIN',
  DESTINATION: 'DESTINATION',
  ALL: 'ALL',
}

export const enumWarehouseOpeningBalanceErrorItemType = {
  INVALID_HEADERS: 'INVALID_HEADERS',
  MISSING_PRODUCT: 'MISSING_PRODUCT',
  MISSING_WAREHOUSE: 'MISSING_WAREHOUSE',
  MISSING_QUANTITY: 'MISSING_QUANTITY',
  MISSING_COST: 'MISSING_COST',
  INVALID_QUANTITY: 'INVALID_QUANTITY',
  ROW_DUPLICATE: 'ROW_DUPLICATE',
  PRODUCT_AMBIGUOUS: 'PRODUCT_AMBIGUOUS',
  WAREHOUSE_AMBIGUOUS: 'WAREHOUSE_AMBIGUOUS',
  PRODUCT_NOT_FOUND: 'PRODUCT_NOT_FOUND',
  WAREHOUSE_NOT_FOUND: 'WAREHOUSE_NOT_FOUND',
  INVALID_DATA: 'INVALID_DATA',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
}

export const enumWarehouseOpeningBalanceSortField = {
  PRODUCT_DISPLAY_NAME: 'PRODUCT_DISPLAY_NAME',
  PRODUCT_SKU: 'PRODUCT_SKU',
  WAREHOUSE_NAME: 'WAREHOUSE_NAME',
  QUANTITY: 'QUANTITY',
  COST_PER_UNIT: 'COST_PER_UNIT',
  TOTAL_COST: 'TOTAL_COST',
}

export const enumWarehouseSource = {
  SHOPIFY: 'SHOPIFY',
  USER_MANUAL: 'USER_MANUAL',
  AMAZON: 'AMAZON',
  TRACKSTAR_FBA: 'TRACKSTAR_FBA',
  TIK_TOK: 'TIK_TOK',
}

export const enumWarehousesProductPurchasesBreakdownSortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
}

export const enumWarehousesProductPurchasesBreakdownSortField = {
  DISPLAY_NAME: 'DISPLAY_NAME',
  RECEIVED_ON: 'RECEIVED_ON',
  ASSEMBLED: 'ASSEMBLED',
  PURCHASED: 'PURCHASED',
  FULFILLED: 'FULFILLED',
  WAREHOUSE_TRANSFERS: 'WAREHOUSE_TRANSFERS',
  ADJUSTMENTS: 'ADJUSTMENTS',
  RESTOCKED: 'RESTOCKED',
  ON_HAND: 'ON_HAND',
  LANDED_COST_PER_UNIT: 'LANDED_COST_PER_UNIT',
  ON_HAND_COST: 'ON_HAND_COST',
  UNAVAILABLE: 'UNAVAILABLE',
  NET_DEPLETED: 'NET_DEPLETED',
}

export const enumWarehouseTransferCostLineItemType = {
  SHIPPING: 'SHIPPING',
  GENERAL: 'GENERAL',
  VENDOR_FEES: 'VENDOR_FEES',
  SHIPPING_SURCHARGE: 'SHIPPING_SURCHARGE',
}

export const enumWarehouseTransfersSortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
}

export const enumWarehouseTransfersSortField = {
  ARRIVAL_DATE: 'ARRIVAL_DATE',
  SHIPPING_DATE: 'SHIPPING_DATE',
  ORIGIN_WAREHOUSE: 'ORIGIN_WAREHOUSE',
  DESTINATION_WAREHOUSE: 'DESTINATION_WAREHOUSE',
  STATUS: 'STATUS',
  ID: 'ID',
  COST: 'COST',
  PAID_STATUS: 'PAID_STATUS',
}

export const enumWarehouseTransferStatus = {
  DRAFT: 'DRAFT',
  SCHEDULED: 'SCHEDULED',
  IN_TRANSIT: 'IN_TRANSIT',
  TRANSFERRED: 'TRANSFERRED',
}

export const enumYearEndDomainMode = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
}

export const enumYearEndDomainState = {
  INACTIVE: 'INACTIVE',
  OPEN: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  CLOSED: 'CLOSED',
}

export const enumYearEndDomainStateErrors = {
  COMPANY_YEAR_END_DOMAIN_STATE_NOT_FOUND:
    'COMPANY_YEAR_END_DOMAIN_STATE_NOT_FOUND',
  INVALID_YEAR_END_DOMAIN_STATE_CHANGE: 'INVALID_YEAR_END_DOMAIN_STATE_CHANGE',
  INVALID_YEAR_END_DOMAIN_DATA_CHANGE: 'INVALID_YEAR_END_DOMAIN_DATA_CHANGE',
  YEAR_END_STATE_BLOCKED_FOR_CHANGES: 'YEAR_END_STATE_BLOCKED_FOR_CHANGES',
}

export const enumYearEndDomainTypes = {
  BANKS: 'BANKS',
  TRANSACTIONS: 'TRANSACTIONS',
  UNCLASSIFIED_TRANSACTIONS: 'UNCLASSIFIED_TRANSACTIONS',
  UNMATCHED_PAYOUTS_AND_TRANSFERS: 'UNMATCHED_PAYOUTS_AND_TRANSFERS',
  PAYMENTS: 'PAYMENTS',
  INVENTORY: 'INVENTORY',
  LOANS: 'LOANS',
  EQUITY: 'EQUITY',
  PAYROLL: 'PAYROLL',
  SALES_TAX: 'SALES_TAX',
  INVESTMENTS: 'INVESTMENTS',
  SECURITY_DEPOSITS: 'SECURITY_DEPOSITS',
  ACCOUNTING_AND_TAX_INFORMATION: 'ACCOUNTING_AND_TAX_INFORMATION',
  ORDERS: 'ORDERS',
  INVOICES: 'INVOICES',
  BILLS: 'BILLS',
}

export const enumYearEndState = {
  INACTIVE: 'INACTIVE',
  NA: 'NA',
  OPEN: 'OPEN',
  INITIAL_PROCESSING: 'INITIAL_PROCESSING',
  AWAITING_USER_FEEDBACK: 'AWAITING_USER_FEEDBACK',
  FOLLOW_UP_PROCESSING: 'FOLLOW_UP_PROCESSING',
  CLOSED: 'CLOSED',
}

export const enumYearEndStateErrors = {
  COMPANY_NOT_FOUND: 'COMPANY_NOT_FOUND',
  COMPANY_YEAR_END_STATE_NOT_FOUND: 'COMPANY_YEAR_END_STATE_NOT_FOUND',
  INVALID_YEAR_END_STATE_CHANGE: 'INVALID_YEAR_END_STATE_CHANGE',
  COMPANY_HAS_ANOTHER_YEAR_END_UNDER_REVIEW:
    'COMPANY_HAS_ANOTHER_YEAR_END_UNDER_REVIEW',
}

export const enumYearEndStateUpdaterType = {
  USER: 'USER',
  SYSTEM: 'SYSTEM',
  OPS: 'OPS',
}

export var generateQueryOp = function(fields) {
  return generateGraphqlOperation('query', typeMap.Query, fields)
}
export var generateMutationOp = function(fields) {
  return generateGraphqlOperation('mutation', typeMap.Mutation, fields)
}
export var generateSubscriptionOp = function(fields) {
  return generateGraphqlOperation('subscription', typeMap.Subscription, fields)
}
export var everything = {
  __scalar: true,
}
